/// <reference path='../../interfaces/interfaces.d.ts' />
import functions = require('../../global/functions');

'use strict';

class EmployeeDetailController {
    public static $inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$uibModal',
        '$http',
        '$timeout',
        'Employee',
        'Process',
        'User',
        'Orgs',
        'bsLoadingOverlayService',
        'toaster',
        'Upload',
        '$q',
        '$document',
        /*'SaveInlineService'*/
    ];

    public hasAllowanceFeature = false;
    public payrollAllowanceData = {
        basicSalary: {
            monthly: 0,
            yearly: 0
        },
        totalAllowance: {
            monthly: 0,
            yearly: 0
        },
        totalDeduction: {
            monthly: 0,
            yearly: 0
        },
        totalSalary: {
            monthly: 0,
            yearly: 0
        },
        allowances: [],
        deductions: []
    };
    public employeeID;
    public employee;
    public isMe;
    public isEmployee;
    public isSubordinate;
    public isDirectSubordinate;
    public isAdmin;
    public checkPermission;
    public schema;
    public org_schema;
    public benefits_expanded;
    public org;
    public leave_form;
    public leave;
    public leaveConfig;
    public today;
    public contract_start_date;
    public leaves_item;
    public new_subordinate;
    public subord_candidates;
    public editing;
    public editing_new;
    public act;
    public defs;
    public forms;
    public form_models = {};
    public personal;
    public employment;
    public dependant;
    public document;
    public add_document = false;
    public language;
    public benefits;
    public structure_office: any;
    public structure_division: any;
    public structure_department: any;
    public showActiveEmail: boolean;
    public newNote;
    public can_comment;
    public employee_clearance;
    public lateness;
    public lateArrivals = [];
    public userName;
    public userSalary;
    public userJobTitle;
    public userManager;
    public payrollBenefits = [];
    public payrollBenefitsDetails = {};
    public employeeBenfits = [];
    public benefitDesc = [];
    public not_insurance_only_client = true;
    public modalDocumentObj = {
        docType: '',
        docExpiryDate: '',
        docFile: ''
    };
    public user_clearances = [
        {
            clearance: 'admin',
            description: 'HR Manager',
            order: 0
        },
        {
            clearance: 'edit',
            description: 'HR Administrator',
            order: 1
        },
        {
            clearance: 'audit',
            description: 'C - level',
            order: 2
        },
        {
            clearance: '',
            description: 'Employee',
            order: 3
        }];
    public dependantIndex;
    public currentDependantObj = {
        name: '',
        birthDate: undefined,
        relation: '',
        nationality: '',
        inHouseVisa: false,
        inHouseMedAid: false,
        visa: {
            number: '',
            expiryDate: '',
            file: ''},
        passport: {
            number: '',
            expiryDate: '',
            file: ''},
        emiratesId: {
            number: '',
            expiryDate: '',
            file: ''},
        medInsuranceCard: {
            number: '',
            expiryDate: '',
            file: ''},
        tob: {
            number: undefined,
            expiryDate: undefined,
            file: ''},
        networkList: {
            number: undefined, 
            expiryDate: undefined,
            file: ''
        }
    };
    public newDependantObj = {
        name: '',
        birthDate: '',
        relation: '',
        nationality: '',
        inHouseVisa: false,
        inHouseMedAid: false,
        visa: {
            number: '',
            expiryDate: '',
            file: ''},
        passport: {
            number: '',
            expiryDate: '',
            file: ''},
        emiratesId: {
            number: '',
            expiryDate: '',
            file: ''},
        medInsuranceCard: {
            number: '',
            expiryDate: '',
            file: ''},
        tob: {
            number: undefined,
            expiryDate: undefined,
            file: ''},
        networkList: {
            number: undefined, 
            expiryDate: undefined,
            file: ''
        }
    };
    public currentUserProfile = {
        firstName: '',
        lastName: '',
        birthDate: undefined,
        gender: '',
        maritalStatus: '',
        religion: '',
        nationality : '',
        languages: [],
        homeAddress: '',
        homePhoneNumber: '',
        homeEmail: '',
        workAddress: '',
        workPhoneNumber: '',
        workMobile: '',
        workEmail: '',
        emergencyContactName: '',
        emergencyContactAddress: '',
        emergencyContactPhoneNumber: '',
        emergencyContactRelation: '',
        medicalRecordNumber: '',
        covidVaccinationReceived: false,
        covidSecondVaccinationDate: null,
        covidVaccinationCertificate: null,
        covidVaccinationCertificateFilename: null
    };
    public newEmploymentProfile = {
        department: {},
        superior: undefined,
        jobTitle: '',
        startDate: '',
        userRole: '',

        bankName: '',
        bankAddress: '',
        routingCode: '',
        accountNumber: '',
        ibanNumber: '',
        accountName: '',

        businessLicence: '',
        contractType: '',
        contractNumber: '',
        contractStartDate: '',
        contractEndDate: '',
        employmentFile : '',
        employmentFilename : ''
    };
    public currentEmploymentProfile = {
        department: {},
        superior: undefined,
        jobTitle: '',
        startDate: '',
        endDate: '',
        userRole: '',
        bankName: '',
        bankAddress: '',
        routingCode: '',
        accountNumber: '',
        ibanNumber: '',
        accountName: '',
        businessLicence: '',
        contractType: '',
        contractNumber: '',
        contractStartDate: '',
        contractEndDate: '',
        employmentFile : '',
        employmentFilename: '',
        workWeek: ''
    };
    public currentLeaveProfile = {
        startDate: '',
        paidLeavePerYear: '',
        paidLeaveCarriedForward: '',
        sickLeavePerYear: '',
        sickLeaveCarriedForward: '',
        maternityLeavePerYear: '',
        maternityLeaveCarriedForward: '',
        paternityLeavePerYear: '',
        paternityLeaveCarriedForward: ''
    };
    public newPayrollProfile = {
        monthlySalaryIL : '',
        benefitsInLine : []
    };
    public currentPayrollProfile = {
        monthlySalaryIL : '',
        benefitsInLine : []
    };
    public monthlySalaryIL;
    public benefitsInLine = [];
    public inlineApiData = {
        id : '',
        fieldName: '',
        currentValue: '',
        newValue: undefined,
        dataVersionId: ''
    };
    public personalGender = [];
    public personalMaritalStatus = [];
    public personalReligion = [];
    public personalNationality = [];
    public personalLanguages = [];
    public leaveTypes = [];
    public tempClearance = '';
    public employmentOffices = [];
    public employmentDivision = [];
    public employmentDepartment = [];
    public employmentUserRole = ['HR Manager', 'HR Administrator', 'C - Level', 'Employee'];
    public employmentBusinessLicence = [];
    public employmentContractType = ['full time', 'part time', 'contract', 'other', 'limited'];
    public contractFileName;

    // value all inline-editing fields require to fallback on if the value is undefined/empty
    public defaultValue = '';
    public depRelation = ['Spouse', 'Child', 'Parent', 'Maid', 'Driver', 'Other'];

    // object required for upload file directive to upload a file.
    public fileDirModel = {
        fileName: 'Select a file',
        fileLink: undefined
    };
    public fileName = <any>{};
    public fields;
    public errors = false;
    public files = {
        visa: undefined,
        passport: undefined,
        emiratesId: undefined
    };
    public isHelping = false;
    public showOverlayCallOuts = false;
    public docType: string = '';
    public docKey = '';
    public docLabel: string = '';
    public docObj = {
            docIndex: -1,
            number: this.defaultValue,
            expiryDate: this.defaultValue,
            file: this.defaultValue,
            name: this.defaultValue,
            type: this.defaultValue,
            action: ''
    };
    public reviewDocObj = {
            docIndex: -1,
            reviewDate: this.defaultValue,
            file: this.defaultValue,
            description: this.defaultValue,
            action: ''
    };
    public checkboxTest = true;
    public showRowSubOrdinate = true;
    public EmployeeDocumentTypes = ['Passport', 'Visa', 'Emirates ID', 'Labour Card' , 'Other Documents'];
    public isPassportUpload = false;

    public leave_types_hrm = ['paid', 'unpaid', 'sick', 'maternity', 'paternity', 'compassionate', 'work from home'];
    public leave_types_manager = ['sick', 'work from home'];
    public leave_types;

    public leave_process = {
        type: undefined,
        start_date: undefined,
        end_date: undefined,
        file: undefined,
        note: undefined,
        half_day: false,
        deduct_payroll: false
    };
    public employeeSelectList = [];
    public workWeekList = [];

    // callouts
    public isCurrent = -1;
    public employeeDepartment = this.defaultValue;
    public employeeDivision = this.defaultValue;
    public employeeOffice = this.defaultValue;
    public officeIndex;
    public divisionIndex;
    public departmentIndex;
    public year_salary;

    // variable to handle empty/non-empty superior fields
    public convertedSuperior;

    private empEventName: string;
    private empEventAddData: string;

    public leaveTabSelected = 0;

    constructor(private $scope: INavbarScope,
                private $state: ng.ui.IStateService,
                private $stateParams: IEmpHistoryState,
                private $uibModal: any,
                private $http: ng.IHttpService,
                private $timeout: ng.ITimeoutService,
                private Employee: IEmpService,
                private Process: IProcessService,
                private User: IUserService,
                private Orgs: IOrgsService,
                private bsLoadingOverlayService: IBsLoadingService,
                private toaster: toaster.IToasterService,
                private Upload: any,
                private $q: angular.IQService,
                public $document,
            ) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;            
        bsLoadingOverlayService.start({referenceId: 'loader'});
        this.act = functions.act;
        this.checkPermission = User.hasPermission;
        this.$uibModal = $uibModal;
        this.not_insurance_only_client = !User.getCurrentUser().isInsuranceOnlyClient;


        // NOTE: do we need these anymore?
        this.defs = {
            personal: {
                form: ['first_name', 'last_name', 'birth_date', 'gender',
                    'marital_status', 'religion', 'nationality',
                    {
                        key: 'languages',
                        type: 'array',
                        items: [{
                            key: 'languages[]',
                            type: 'select',
                            titleMap: []
                        }]
                    }, 'lang', 'contact'],
                deselect: () => {
                    this.dependant = undefined;
                    this.employment = undefined;
                }
            },
            employment: {
                form: ['title', 'start_date', 'bank_account', 'contract'],
                form_me: ['bank_account'],
                others: ['superior', 'structure'],
                deselect: () => {
                    this.personal = undefined;
                    this.document = undefined;
                }
            },
            superior: {
                schema: {
                    type: 'object',
                    properties: {
                        id: {title: 'Superior', type: 'string', format: 'employee_id'}
                    }
                },
                update: (f) => {
                    this.employee.superior = f(this.employee.superior || {});
                }
            },
            structure: {
                update: (f) => {
                    this.employee.extra.employment['structure'] = f(
                        this.employee.extra.employment['structure'] || {}
                    );
                }
            },
            document: {
                form: ['number', 'expiry_date', 'file', 'note'],
                form_new: ['number', 'expiry_date', 'file', 'note'],
                form_new_type: ['type'],
                form_new_name: ['name'],
                update_list: (f) => {
                    this.employee.extra.employment.documents = f(
                        this.employee.extra.employment.documents || []
                    );
                    this.add_document = true;
                }
            },
            dependant: {
                update_list: (f) => {
                    this.employee.extra.personal.dependants = f(
                        this.employee.extra.personal.dependants || []
                    );
                }
            }, 
            monthlysalary: {
                schema: {
                    type: 'object',
                    properties: {
                        monthlysalary: {
                            title: 'Monthly Salary', type: 'number'
                        }
                    }
                },
                update: (f) => {
                    this.employee.monthlysalary = f(
                        {monthlysalary: this.employee.monthlysalary * 1}).monthlysalary.toString();
                },
                deselect: (f) => {
                    this.personal = undefined;
                    this.employment = undefined;
                }
            },
            benefits: {
                update: (f) => {
                    this.employee.extra.employment.benefits = f({benefits: this.employee.extra.benefits || []}).benefits;
                }
            },
            leave: {
                update: (f) => {
                    this.employee.extra.leave = f(this.employee.extra.leave || {});
                }
            },
            lateArrivals: {
                update: (f) => {
                    this.employee.extra.lateArrivals = f(this.employee.extra.lateArrivals || {});
                }
            }
        };
        
        this.load();
        this.today = new Date();
        this.isAdmin = User.getCurrentUser().userData.user.clearance === 'admin';
        this.setLabelFiles();
        $scope.$emit('$pageWithHelpVisited', 5);

    }
    /** FUNCTIONS: LOADING */

    private load(): void {
        this.Orgs.getOrgFromCache((response) => {
            this.org = response;
            // Check new features
            if (this.org.extra.trial && this.org.extra.trial.enrolled ) {
                this.hasAllowanceFeature = true;
            }

            // payroll benefits dropdown list
            if (this.org.extra && this.org.extra.benefits) {
                for (var i: number = 0; i < this.org.extra.benefits.length; i++ ) {
                    let benefit = this.org.extra.benefits[i];
                    this.payrollBenefits.push(benefit.name);
                    this.payrollBenefitsDetails[benefit.name] = this.org.extra.benefits[i];
                    if (benefit.documents && benefit.documents.length >= 1) {
                        this.payrollBenefitsDetails[benefit.name].numDocs = benefit.documents.length;
                    } else {
                        this.payrollBenefitsDetails[benefit.name].numDocs = 0;
                    }
                }
            } else {
                this.org.extra.benefits = [{}];
            }

            // Setup work week mappings
            this.workWeekList.length = 0;
            this.workWeekList.push('Default');
            //console.log(JSON.stringify(this.org.extra));
            //console.log(JSON.stringify(this.org.extra.leave));
            
            if (this.org.extra.leave && this.org.extra.leave.work_weeks) {            
                for (const workweek of this.org.extra.leave.work_weeks) {
                    this.workWeekList.push(workweek.description);
                }
            }


            this.Orgs.loadSchema().then((r) => {
                this.org_schema = r.data;
                this.checkLoading();
            }, (e) => {
                console.log(e);
            });

            // get a list of business licences for the org in all offices - total business licence list
            if (this.org.extra && this.org.extra.offices) {
                for (var z: number = 0; z < this.org.extra.offices.length; z ++) {
                    if (this.org.extra.offices[z].business_licences !== undefined) {
                        for (var x: number = 0; x < this.org.extra.offices[z].business_licences.length; x ++) {
                            this.employmentBusinessLicence.push(
                                this.org.extra.offices[z].business_licences[x].name
                            );
                        }
                    }
                }
            }

            this.Employee.loadEmployee(this.$stateParams.id).then((response: Restangular.IResponse) => {
                this.employeeID = this.$stateParams.id;
                this.employee = response;             
                this.userName = this.employee.extra.personal.first_name + ' ' + this.employee.extra.personal.last_name;

                // decide what to show on the employees overview page for their Job Title if it/is not set
                if (!this.employee.extra.employment.title) {
                    this.userJobTitle = 'Job title not set';
                } else {
                    this.userJobTitle = this.employee.extra.employment.title;
                }

                // decide what to show on the employees overview page for their salary if it/is not set
                if (!this.employee.monthlysalary) {
                    this.userSalary = 'Monthly salary not set';
                    this.year_salary = 'Monthly salary must be set to see yearly salary';
                } else {
                    this.year_salary = this.employee.monthlysalary * 12;
                    this.userSalary = this.employee.monthlysalary;
                
                    this.payrollAllowanceData.basicSalary.monthly = this.userSalary;
                    this.payrollAllowanceData.basicSalary.yearly = this.year_salary;
                    this.payrollAllowanceData.totalSalary.monthly = this.userSalary;
                    this.payrollAllowanceData.totalSalary.yearly = this.year_salary;
                }
                
                // // Add Allowances
                // if (this.employee.extra.employment && this.employee.extra.employment.allowances) {
                //     this.employee.extra.employment.allowances.map(allowance => {
                //         this.payrollAllowanceData.allowances.push({
                //             description: allowance.description,
                //             monthly: allowance.amount,
                //             yearly: allowance.amount * 12
                //         });
                //
                //         this.payrollAllowanceData.totalAllowance.monthly += allowance.amount;
                //         this.payrollAllowanceData.totalAllowance.yearly += allowance.amount*12;
                //
                //         this.payrollAllowanceData.totalSalary.monthly += allowance.amount;
                //         this.payrollAllowanceData.totalSalary.yearly += allowance.amount*12;
                //     });
                // }
                //
                // // Subtract deductions
                //     let current_month = moment().format('YYYY-MM');
                // if (this.employee.extra.employment && this.employee.extra.employment.deductions) {
                //     this.employee.extra.employment.deductions.map(deduction => {
                //         // Check if it counts for the current month
                //         let valid_for_month = deduction.valid_for.substring(0, 7);
                //         console.log(valid_for_month);
                //         console.log(current_month);
                //         if (current_month == valid_for_month) {
                //             this.payrollAllowanceData.deductions.push({
                //                 description: deduction.description,
                //                 monthly: deduction.amount,
                //                 yearly: deduction.amount * 12
                //             });
                //         }
                //
                //         this.payrollAllowanceData.totalDeduction.monthly += deduction.amount;
                //
                //         this.payrollAllowanceData.totalSalary.monthly -= deduction.amount;
                //     });
                // }
                //


                // if the current org has no offices create a blank object for it to avoid undefined errors.
                if (this.org.extra.offices === undefined) {
                    this.org.extra.offices = [];
                }

                // first get a list of the current organisations offices if they have added at least 1 office
                if (this.org.extra.offices.length >= 0) {

                    /**
                     * by default get a list of offices in the org for the dropdowns in the employment profile
                     * push the office name(s) into an array so that the user can select an option from the list.
                     */
                    for (var j: number = 0; j < this.org.extra.offices.length; j ++) {
                        this.employmentOffices.push(this.org.extra.offices[j].name);
                    }
                } else {

                    // if they have no offices then make it an empty array
                    this.employmentOffices = [];
                }

                let structure: any = this.employee.extra.employment.structure;
                if (structure === undefined) {
                    structure = {};
                }
                if (structure.office) {

                    // get a list of current division because this employee has a office assigned to them
                    this.officeIndex = this.employmentOffices.indexOf(this.employee.extra.employment.structure.office);
                    if (this.officeIndex >= 0 && this.org.extra.offices[this.officeIndex]['divisions']) {
                        for (var k: number = 0; k < this.org.extra.offices[this.officeIndex].divisions.length; k++) {
                            this.employmentDivision.push(this.org.extra.offices[this.officeIndex].divisions[k].name);
                        }
                    }

                    if (structure.division) {

                        // get a list of current departments because this employee has a division
                        this.divisionIndex = this.employmentDivision.indexOf(this.employee.extra.employment.structure.division);
                        if (this.divisionIndex >= 0 && this.org.extra.offices[this.officeIndex].divisions[this.divisionIndex]['departments']) {
                            for (var l: number = 0; l < this.org.extra.offices[this.officeIndex].divisions[this.divisionIndex].departments.length; l++) {
                                this.employmentDepartment.push(this.org.extra.offices[this.officeIndex].divisions[this.divisionIndex].departments[l].name);
                            }
                        }
                    }
                }
               
                this.processLoadEmployee();
            }).catch((err) => {
                this.toaster.pop('error', 'Error', err.data.detail);
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                window.location.href = '#!/employees';
            });


            /**
             * load employees for superior dropdown
             * there are two calls here because one returns C-Level+ employees and the other call returns only Employee Users
             * also does not return inactive employees
             */
            this.Employee.allEmployees(this.org.id, 0)
                .then(empResponse => {
                    let lemployees: any[] = empResponse.results;
                    for (var h: number = 0; h < lemployees.length; h++) {
                        let employee: any = {
                            id: lemployees[h].id,
                            name: lemployees[h].displayname
                        };

                        // list used in the autocomplete dropdown
                        this.employeeSelectList.push(employee);
                    }
                }
            );

            this.Employee.allNonEmployees(this.org.id).then(empResponse2 => {
                for (var f: number = 0; f < empResponse2.length; f ++) {
                    if (empResponse2[f].active === true) {
                        let employee: Object = {
                            id: empResponse2[f].id,
                            name: empResponse2[f].displayname
                        };

                        this.employeeSelectList.push(employee);
                    }
                }
            });
        });

        this.Employee.loadSchema()
            .then((response: any) => {
                this.schema = response.data;
                this.personalGender = this.schema.properties.personal.properties.gender.enum;
                this.personalMaritalStatus = this.schema.properties.personal.properties.marital_status.enum;
                this.personalReligion = this.schema.properties.personal.properties.religion.enum;
                this.personalNationality = this.schema.properties.personal.properties.nationality.enum;
                this.personalLanguages = this.schema.properties.personal.properties.languages.items.enum;
                this.leaveTypes = this.schema.properties.leaves.items.properties.type.enum;
                var languages_form: any = this.defs.personal.form.filter(x => x['key'] === 'languages')[0];
                languages_form.items[0].titleMap = this.schema.properties.personal.properties.languages.items.enum.map((e) => ({
                    name: e,
                    value: e
                }));

                this.checkLoading();
            }
        );

        this.loadSubOrdCandidates();

    }

    // gets a list of employees that are valid
    private loadSubOrdCandidates(): void {
        this.Employee.listSubordinateCandidates(this.$stateParams.id)
            .then((response: Restangular.IResponse) => {
                this.subord_candidates = response;
            }
        );
    }

    // called in load function
    private processLoadEmployee(): void {

        // check to see if the current employee actually has a profile picture, if they dont give them the default profile image
        this.employee.extra.image = this.employee.extra.image && this.employee.extra.image !== '/static/images/placeholder-nobody2.png' 
            ? this.employee.extra.image 
            : '/static/images/placeholder-nobody2.png';

        this.contract_start_date = _.get(this.employee.extra, 'leave.start_date', undefined) 
            ? new Date(this.employee.extra.leave.start_date) 
            : undefined;

        // toggles whether to show if the send activate email button is resend/send
        this.showActiveEmail = this.employee.extra.invite_email || false;

        this.leaveConfig = functions.get_leave_config(this.employee, this.org, this.org_schema);
        // FIXME: Add check
        this.can_comment = true;
        if (!this.employee.extra.personal) {
            this.employee.extra.personal = {
                contact: {
                    home: {},
                    work: {},
                    emergency: {},
                    dependants: {},
                    health: {}
                }
            };
        }

            // decide what to show on the employees overview page for their salary if it/is not set
            if (!this.employee.monthlysalary) {
                this.userSalary = 'Monthly salary not set';
                this.year_salary = 'Monthly salary must be set to see yearly salary';
            } else {
                this.year_salary = this.employee.monthlysalary * 12;
                this.userSalary = this.employee.monthlysalary * 1;

                this.payrollAllowanceData.basicSalary.monthly = this.userSalary;
                this.payrollAllowanceData.basicSalary.yearly = this.year_salary;
                this.payrollAllowanceData.totalSalary.monthly = this.userSalary;
                this.payrollAllowanceData.totalSalary.yearly = this.year_salary;
            }

            // Add Allowances
            this.payrollAllowanceData.allowances = [];
            this.payrollAllowanceData.totalAllowance.monthly = 0;
            this.payrollAllowanceData.totalAllowance.yearly = 0;

            if (this.employee.extra.employment && this.employee.extra.employment.allowances) {
                this.employee.extra.employment.allowances.map(allowance => {
                    this.payrollAllowanceData.allowances.push({
                        description: allowance.description,
                        monthly: allowance.amount,
                        yearly: allowance.amount * 12
                    });

                    this.payrollAllowanceData.totalAllowance.monthly += allowance.amount;
                    this.payrollAllowanceData.totalAllowance.yearly += allowance.amount*12;

                    this.payrollAllowanceData.totalSalary.monthly += allowance.amount;
                    this.payrollAllowanceData.totalSalary.yearly += allowance.amount*12;
                });
            }
            // Subtract deductions
            this.payrollAllowanceData.deductions = [];
            this.payrollAllowanceData.totalDeduction.monthly = 0;
            this.payrollAllowanceData.totalDeduction.yearly = 0;

            let current_month = moment().format('YYYY-MM');
            if (this.employee.extra.employment && this.employee.extra.employment.deductions) {
                this.employee.extra.employment.deductions.map(deduction => {
                    // Check if it counts for the current month
                    let valid_for_month = deduction.valid_for.substring(0, 7);
                    if (current_month == valid_for_month) {
                        this.payrollAllowanceData.deductions.push({
                            description: deduction.description,
                            monthly: deduction.amount,
                            yearly: deduction.amount * 12
                        });
                    }

                    this.payrollAllowanceData.totalDeduction.monthly += deduction.amount;

                    this.payrollAllowanceData.totalSalary.monthly -= deduction.amount;
                });
            }


        // handle employee properties that are empty for blank employees and add back empty objects
        if (!this.employee.superior) {
            this.employee.superior = undefined;
        }
        if (!this.employee.extra.personal) {
            this.employee.extra.personal = {};
        }
        if (!this.employee.extra.personal.languages) {
            this.employee.extra.personal.languages = [];
        }
        if (!this.employee.extra.personal.contact) {
            this.employee.extra.personal.contact = {};
        }
        if (!this.employee.extra.personal.contact.home) {
            this.employee.extra.personal.contact.home = {};
        }
        if (!this.employee.extra.personal.contact.work) {
            this.employee.extra.personal.contact.work = {};
        }
        if (!this.employee.extra.personal.contact.emergency) {
            this.employee.extra.personal.contact.emergency = {};
        }
        if (!this.employee.extra.personal.health) {
            this.employee.extra.personal.health = {};
        }
        if (!this.employee.extra.employment) {
            this.employee.extra.employment = {};
        }
        if (!this.employee.extra.employment.bank_account) {
            this.employee.extra.employment.bank_account = {};
        }
        if (!this.employee.extra.employment.contract) {
            this.employee.extra.employment.contract = {};
        }

        if (!this.employee.extra.personal.health) {
            this.employee.extra.personal.health = {};
        }

        // refresh and parse late arrivals
        this.processLateArrivals();
        this.user_clearances.forEach(c => {
            if (c.clearance === this.employee.user.clearance) {
                this.employee_clearance = c;
            }
        });

        // used to parse the correct name per clearance for the user role dropdown under the employment tab
        switch (this.employee.user.clearance) {
            case('admin'): {
                this.tempClearance = 'HR Manager';
                break;
            }
            case('edit'): {
                this.tempClearance = 'HR Administrator';
                break;
            }
            case('audit'): {
                this.tempClearance = 'C - Level';
                break;
            }
            default: {
                this.tempClearance = 'Employee';
                break;
            }
        }

        if (this.employee.subordinates.length === 0) {
            this.showRowSubOrdinate = false;
        }
        
        /**
         *  check superior - if they already have one save that to the currentEmployment var 
         * if not pass it an empty string 
         * md-autocomplete requires a blank string for empty selected value.
         */ 
        if (!this.employee.superior) {
            this.convertedSuperior = undefined;
        } else {
            this.convertedSuperior = {
                id: this.employee.superior.id,
                name: this.employee.superior.displayname};
        }
         //console.log(JSON.stringify(this.employee.deleted_leave_data));
         // console.log(JSON.stringify(this.employee.pending_leave_data));
         
         //console.log(JSON.stringify(this.employee.extra.leaves));
        
        this.checkLoading();
        
        /**
         * reassign the employee object values to local models that are used for the inplace editing
         * this is done in this manner to account for undefined/blank values in the employee obj 
         * variables for the Personal tab
         */
        this.currentUserProfile = {
            firstName: this.employee.extra.personal.first_name || this.defaultValue,
            lastName: this.employee.extra.personal.last_name || this.defaultValue,
            birthDate: new Date(this.employee.extra.personal.birth_date) || undefined,
            gender: this.employee.extra.personal.gender || this.defaultValue,
            maritalStatus: this.employee.extra.personal.marital_status || this.defaultValue,
            religion: this.employee.extra.personal.religion || this.defaultValue,
            nationality: this.employee.extra.personal.nationality || this.defaultValue,
            languages: this.employee.extra.personal.languages || [],
            homeAddress: this.employee.extra.personal.contact.home.address || this.defaultValue,
            homePhoneNumber: this.employee.extra.personal.contact.home.phone_number || this.defaultValue ,
            homeEmail: this.employee.extra.personal.contact.home.email || this.defaultValue,
            workAddress: this.employee.extra.personal.contact.work.address || this.defaultValue ,
            workPhoneNumber: this.employee.extra.personal.contact.work.phone_number || this.defaultValue ,
            workMobile: this.employee.extra.personal.contact.work.mobile_number || this.defaultValue ,
            workEmail: this.employee.extra.personal.contact.work.email || this.defaultValue,
            emergencyContactName: this.employee.extra.personal.contact.emergency.name || this.defaultValue,
            emergencyContactAddress:  this.employee.extra.personal.contact.emergency.address || this.defaultValue,
            emergencyContactPhoneNumber: this.employee.extra.personal.contact.emergency.phone_number || this.defaultValue,
            emergencyContactRelation: this.employee.extra.personal.contact.emergency.relation || this.defaultValue,
            medicalRecordNumber: this.employee.extra.personal.health.medical_record_number || this.defaultValue,
            covidVaccinationReceived: this.employee.extra.personal.health.covid_vaccination_received || false,
            covidSecondVaccinationDate: this.employee.extra.personal.health.covid_vaccination_second_date || null,
            covidVaccinationCertificate: this.employee.extra.personal.health.covid_vaccination_certificate || null,
            covidVaccinationCertificateFilename: this.parseFileName(this.employee.extra.personal.health.covid_vaccination_certificate) || null,

        };

        // variables for the Employment & Docs tab
        this.currentEmploymentProfile = {
            department: this.employee.extra.employment.structure || this.defaultValue,
            superior: this.convertedSuperior,
            jobTitle: this.employee.extra.employment.title || this.defaultValue,
            startDate: this.employee.extra.employment.start_date || this.defaultValue,
            endDate: this.employee.extra.employment.end_date || this.defaultValue,
            userRole: this.tempClearance || this.defaultValue,
            bankName: this.employee.extra.employment.bank_account.bank_name || this.defaultValue,
            bankAddress: this.employee.extra.employment.bank_account.bank_address || this.defaultValue,
            routingCode: this.employee.extra.employment.bank_account.bank_route || this.defaultValue,
            accountNumber: this.employee.extra.employment.bank_account.account_number || this.defaultValue,
            ibanNumber: this.employee.extra.employment.bank_account.iban_number || this.defaultValue,
            accountName: this.employee.extra.employment.bank_account.account_name || this.defaultValue,
            businessLicence: this.employee.extra.employment.contract.business_licence || this.defaultValue,
            contractType: this.employee.extra.employment.contract.contract_type || this.defaultValue,
            contractNumber: this.employee.extra.employment.contract.number || this.defaultValue,
            contractStartDate: this.employee.extra.employment.contract.start_date || this.defaultValue,
            contractEndDate: this.employee.extra.employment.contract.end_date || this.defaultValue,
            employmentFile : this.employee.extra.employment.contract.file || this.defaultValue,
            employmentFilename : this.parseFileName(this.employee.extra.employment.contract.file) || this.defaultValue,
            workWeek: this.employee.extra.leave.work_week_index || 'Default'
        };

        // additional variables for the office assignment under the Employment and Docs tab
        if (this.employee.extra.employment.structure !== undefined) {
            this.employeeOffice = this.employee.extra.employment.structure.office  || this.defaultValue;
            this.employeeDivision = this.employee.extra.employment.structure.division  || this.defaultValue;
            this.employeeDepartment = this.employee.extra.employment.structure.department  || this.defaultValue;
        }

        // variables for the Payroll & Benefits tab
        this.currentPayrollProfile = {
            monthlySalaryIL : this.employee.monthlysalary || this.defaultValue,
            benefitsInLine : this.employee.extra.employment.benefits || []
        };

        // variables for the Leave tab
        this.currentLeaveProfile = {
            startDate: this.employee.extra.leave.start_date  || this.defaultValue,
            paidLeavePerYear: this.employee.extra.leave.paid_leave_days_per_year  || this.defaultValue,
            paidLeaveCarriedForward: this.employee.extra.leave.paid_leave_carried_forward  || this.defaultValue,
            sickLeavePerYear: this.employee.extra.leave.sick_leave_days_per_year  || this.defaultValue,
            sickLeaveCarriedForward: this.employee.extra.leave.sick_leave_carried_forward  || this.defaultValue,
            maternityLeavePerYear: this.employee.extra.leave.maternity_leave_days_per_year  || this.defaultValue,
            maternityLeaveCarriedForward: this.employee.extra.leave.maternity_leave_carried_forward  || this.defaultValue,
            paternityLeavePerYear:  this.employee.extra.leave.paternity_leave_days_per_year  || this.defaultValue,
            paternityLeaveCarriedForward: this.employee.extra.leave.paternity_leave_carried_forward  || this.defaultValue
        };

        // Check next year's leave
        //this.currentLeaveBuckets =

        if (!this.employee.paid_leave_balance_ny) {
            let nylb = 0;
            if (this.currentLeaveProfile.paidLeavePerYear) {
                let la = parseInt(this.currentLeaveProfile.paidLeavePerYear);
                nylb += la;
            }

            if (this.currentLeaveProfile.paidLeaveCarriedForward) {
                let la = parseInt(this.currentLeaveProfile.paidLeaveCarriedForward);
                nylb += la;
            }
            this.employee.paid_leave_balance_ny = nylb;
        }
    }

    private  checkLoading(): void {
        if (this.schema && this.employee && this.org && this.org_schema) {
            if (_.isEmpty(this.employee.extra.leave) && this.checkPermission('org.change_employee')) {
                const schemaLeaveProperties: any = this.schema.properties.leave.properties;
                const orgExtra: any = this.org.extra;
                const orgLeave: any = orgExtra.leave;

                this.employee.extra.leave = {
                    start_date: this.employee.extra.employment.start_date,
                    paid_leave_days_per_year: orgExtra && orgLeave && orgLeave.paid_leave_days_per_year || schemaLeaveProperties.paid_leave_days_per_year.default,
                    sick_leave_days_per_year: orgExtra && orgLeave && orgLeave.sick_leave_days_per_year || schemaLeaveProperties.sick_leave_days_per_year.default,
                    maternity_leave_days_per_year: orgExtra && orgLeave && orgLeave.maternity_leave_days_per_year || schemaLeaveProperties.maternity_leave_days_per_year.default,
                    paternity_leave_days_per_year: orgExtra && orgLeave && orgLeave.paternity_leave_days_per_year || schemaLeaveProperties.paternity_leave_days_per_year.default
                };
            }
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            let currentUser: any = this.User.getCurrentUser().userData;
            this.isMe = this.employee.id === currentUser.id;

            // check that the logged in user is an employee level user
            this.isEmployee = currentUser.user.clearance === '';

            // default disable manager view
            this.isSubordinate = false;
            this.isDirectSubordinate = false;

            // check if the logged in user is the superior of the profile user - if so activate managers view
            if (this.employee.superior && this.employee.superior.id === currentUser.id) {
                this.isSubordinate = true;
                this.isDirectSubordinate = true;
            }

            // check for second level subordinates eg. subordinates of subordinates also activate manager view
            if (this.employee.superior && currentUser.subordinates) { 
                for (var i: number = 0; i < currentUser.subordinates.length; i++) {
                    if (this.employee.superior.id === currentUser.subordinates[i].id) {
                        this.isSubordinate = true;
                        break;
                    }
                } 
            }
            
            this.benefits_expanded = (((this.employee.extra || {}).employment || {}).benefits || []).map((bn) => {
                let bs: any = this.org.extra.benefits.filter((e) => e.name === bn);
                return bs.concat([{name: bn, description: '', documents: []}])[0];
            });
        }
    }

    /** 
     *  function called on page load, and after creating a new late arrival item
     *  processes the leave items in the employee object to display correctly on the frontend
     */
    public processLateArrivals(): void {
        if (this.employee.extra.lateArrivals) {
            this.lateArrivals = [];
            for (var i: number = 0; i < this.employee.extra.lateArrivals.length; i++) {

                // copy lateArrival to local var
                let laItem: any = {
                    arrival_time: this.employee.extra.lateArrivals[i].arrival_time,
                    create_date: this.employee.extra.lateArrivals[i].create_date,
                    employee: this.employee.extra.lateArrivals[i].employee,
                    employee_id: this.employee.extra.lateArrivals[i].employee_id,
                    expected_arrival_time: this.employee.extra.lateArrivals[i].expected_arrival_time,
                    reason: this.employee.extra.lateArrivals[i].reason,
                    timeDiff: undefined,
                    minutes: 0,
                    hours: 0,
                    deleted: this.employee.extra.lateArrivals[i].deleted === true
                };

                // calculate the time items needed to display on the table
                laItem.timeDiff = moment(laItem.arrival_time, 'HH:mm')
                    .diff(
                        moment(laItem.expected_arrival_time, 'HH:mm')
                );
                laItem.timeDiff = moment.duration(laItem.timeDiff);
                laItem.minutes = laItem.timeDiff._data.minutes;
                laItem.hours = laItem.timeDiff._data.hours;
                this.lateArrivals.push(laItem);
            }
        }
    }

    // function used to reactivate an inactive employee
    public activate(): void {
        this.Employee.activate(this.employee).then(() => {
            this.toaster.pop('success', 'Success', 'Employee Activated');
        }, () => {
            this.toaster.pop('error', 'Error', 'There was an error processing your request');
        });
    }

    // send email invite to the employee who you are viewing
    public setInviteEmailSent(): void {
        this.Employee.setInviteEmailSent(this.employee).then(() => {
            this.$state.go('root.employees');
        });
    }

    // modal function to confirm an if you want to send an email invite to the current employee
    public invite(): void {
        let that = this;

        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/employee/invite_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.employee = this.employee;
            }],
        });

        modal_instance.result.then((selectedItem) => {
            this.$http.post('/api/employees/' + this.employee.id + '/invite', undefined)
                .then((r) => {
                    that.$scope.$emit('$EL', 'employee.profile.invite');

                    this.toaster.pop('success', 'Invitation Sent');
                    this.setInviteEmailSent();
                }, (r) => {
                    this.toaster.pop('error', 'Server Error', r.data);
                }
            );
        });
    }

    // function to call the calculations for pending leave display on the leave modal in the employment profile 
    public leave_balance(emp_id: string, leave_type: string, start_date: string, end_date: string, half_day: boolean): ng.IPromise<any> {

        // reject the request if the required params are not filled in
        if (start_date === undefined || end_date === undefined || leave_type === undefined) {
            return this.$q.reject();
        }

        let leaveObj: object = {type: leave_type, start_date: start_date, end_date: end_date, half_day: half_day};
        return this.Employee.postLeaveBalanceCheck(emp_id, leaveObj);
    }

    public leaveModal(): void {
        // Select the correct set of leave_types based on user role
        if (this.User.hasPermission('org.change_employee')) {
            this.leave_types = this.leave_types_hrm;
        } else if (this.isDirectSubordinate) {
            this.leave_types = this.leave_types_manager;
        }else {
            // Should not really break through to here
            this.leave_types = [];
        }

        // reset form models when it closes and opens
        this.leave_process = {
            type: undefined,
            start_date: undefined,
            end_date: undefined,
            file: undefined,
            note: undefined,
            half_day: false,
            deduct_payroll: false
        };
        const that: this = this;
        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/employee/leave_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                $scope.C = that;
                $scope.fileLink = '';
                $scope.negativeLB = false;
                let leave_save_item: any = {};
                $scope.handle_data = () => {
                    leave_save_item['type'] = that.leave_process.type;
                    leave_save_item['start_date'] = moment(that.leave_process.start_date).format('YYYY-MM-DD');
                    leave_save_item['end_date'] = moment(that.leave_process.end_date).format('YYYY-MM-DD');

                    // strip undefined/empty form fields from object
                    if (that.leave_process.note) {
                        leave_save_item['note'] = that.leave_process.note;
                    }
                    if (that.leave_process.file) {
                        leave_save_item['file'] = $scope.fileLink;
                    }
                    if (that.leave_process.half_day) {
                        leave_save_item['half_day'] = that.leave_process.half_day;
                    }
                    if (that.leave_process.deduct_payroll) {
                        leave_save_item['deduct_payroll'] = that.leave_process.deduct_payroll;
                    }
                    $scope.ok();
                };
                $scope.leaveUsed = 0;
                $scope.leaveBalanceNextYear = 0;
                $scope.leaveUsedThisYear = 0;
                $scope.leaveUsedNextYear = 0;
                $scope.allowHalfDayLeave = true;
                $scope.spanYear = false;

                // get leave config for current employee
                $scope.leave_config = functions.get_leave_config(that.employee, that.org, that.org_schema);

                let allowHalfday: any = () => {
                    // Only process if start and end dates have been filled in
                    if (!that.leave_process.start_date || !that.leave_process.end_date) {
                        return false;
                    }

                    return that.leave_process.start_date.getTime() === that.leave_process.end_date.getTime();
                };

                let allowPayrollDeduction: any = () => {
                    return that.hasAllowanceFeature && that.leave_process.type === 'unpaid';
                }

                // get the current balance check for the current leave item selected by the user
                let leave_balanceCheck: any = () => {
                    let type: string = that.leave_process.type;

                    //TODO: leave
                    // Only process valid leave types
                    if ((type !== 'paid' && type !== 'sick' && type !== 'maternity' && type !== 'paternity')) {
                        return '';
                    }

                    // Only process if start and end dates have been filled in
                    if (!that.leave_process.start_date || !that.leave_process.end_date) {
                        return '';
                    }

                    let start: any = moment(that.leave_process.start_date).format('YYYY-MM-DD');
                    let end: any = moment(that.leave_process.end_date).format('YYYY-MM-DD');
                    let half_day: boolean = that.leave_process.half_day;

                    // update leave balance according to the leave selected by the user in the modal
                    that.leave_balance(that.employee.id, type, start, end, half_day).then((response: any) => {
                            $scope.leaveBalance = response.data['leave_balance'];
                            $scope.leaveBalanceNextYear = response.data['leave_balance_next_year'];
                            $scope.leaveUsed = response.data['leave_used'];
                            $scope.leaveUsedThisYear = response.data['leave_used_this_year'];
                            $scope.leaveUsedNextYear = response.data['leave_used_next_year'];
                            $scope.spanYear = response.data['span_cycle'];

                            $scope.leaveError = response.data['existing_leave_message'];
                            $scope.leaveMessage = response.data['message'];
                            if ($scope.leaveBalance < 0) {
                                $scope.negativeLB = true;
                            }
                        }, (response: any) => {
                            if (!response) {
                                $scope.leaveBalance = NaN;
                            }
                        }
                    );
                };

                // check that the selected leave is valid - set the text line in the modal that displays the error
                let validate_leave: any = (submit=false) => {
                    if (!that.leave_process.start_date || !that.leave_process.end_date) {
                        var errMsg = '';
                        if (submit) {
                           if (!that.leave_process.start_date) {
                               errMsg = 'Start date not specified';
                           }
                           if (!that.leave_process.end_date) {
                               errMsg = 'Start date not specified';
                           }
                        }
                        return {
                            valid: false,
                            message: errMsg
                        };
                    }

                    let start: Moment = moment(that.leave_process.start_date);
                    let end: Moment = moment(that.leave_process.end_date);
                    let today: Moment = moment({hour: 0});
                    if (end.isBefore(start)) {
                        return {
                            valid: false,
                            message: 'End date must not be before start date'
                        };
                    }

                    return {
                        valid: true,
                        message: ''
                    }
                };

                let validationResult = validate_leave();
                $scope.leaveError = validationResult.message;

                // watch the model object, on change check the balance, validate leave and add .5 if its a half day.
                $scope.$watch(() => that.leave_process, (d) => {
                    $scope.allowHalfDayLeave = allowHalfday();
                    $scope.allowPayrollDeduction = allowPayrollDeduction();

                    if (!$scope.allowHalfDayLeave) {
                        // Uncheck a ticked half-day leave checkbox
                        that.leave_process.half_day = false;
                    }
                    let validationResult = validate_leave();
                    $scope.leaveError = validationResult.message;
                    if (validationResult.valid) {
                        leave_balanceCheck();
                    }
                }, true);

                // upload function to upload documents that are attached to the leave request
                $scope.uploadFiles = (params) => {
                    that.bsLoadingOverlayService.start({referenceId: 'loader'});
                    var file: any = params.new;
                    that.Upload.upload({
                        url:'/api/uploads/other',
                        method: 'POST',
                        data: {file: file}
                    }).then(
                        (response) => {
                            that.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            $scope.fileLink = response.data.url;
                            that.fileDirModel.fileName = that.parseFileName(that.leave_process);
                            
                        },
                        (response) => {
                            that.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            that.toaster.pop('error', 'upload failed', '');
                        }
                    ); 
                };

                // clear the object if the user wants to delete a document
                $scope.deleteFile = () => {
                    $scope.fileLink = undefined;
                    this.fileDirModel.fileName = 'Select a file';
                };

                $scope.disableLeaveSubmit = (leaveError: string, leaveBalance: number, leaveType: string): boolean => {
                    //let type: string = that.leave_process.type;
                   
                    // HR is allowed to add negative leave
                    if (leaveError === '') {
                        if (leaveType == "paid" || leaveType == "sick" || leaveType == "maternity" || leaveType == "paternity") {
                            if ((leaveBalance !== undefined/* && leaveBalance > 0*/)) {
                                return false;
                            } else {
                                return true;
                            }
                        } else if (leaveType == null) {
                            return true;                        
                        } else {
                            return false;
                        }
                    } else {                        
                        return true;                        
                    }
                }


                // submission function for new leave item added directly to user profile - skips the normal trasition steps and is automatically added
                $scope.ok = () => {
                    if (moment(leave_save_item['start_date']).diff(moment(leave_save_item['end_date'])) !== 0 && leave_save_item.half_day) {
                        that.toaster.pop('error', 'Validation Failed', 'Start date and end date has to be the same to request a half day leave');
                    } else {
                        var postleave: any = () => {
                            that.Employee.postLeave(that.$stateParams.id, leave_save_item)
                                .then((response: any) => {
                                    that.emitEvent('employee.profile.leave.add', that.leave_process.type);
                                    $uibModalInstance.close(leave_save_item);
                                    that.toaster.pop('success', 'Success', 'Leave Added');
                                    that.load();
                                }, 
                                (response: any) => {
                                    if (response.status === 400) {
                                        that.toaster.pop('error', 'Validation Failed', response.data[0]);
                                    } else {
                                        that.toaster.pop('error', 'Server Error', response.data.detail);
                                    }
                                }
                            );
                        };

                        if ($scope.negativeLB) {
                            that.$uibModal.open({
                                templateUrl: '/static/templates/modals/request_leave_warning_modal.html',
                                controller: ['$scope', '$uibModalInstance', ($scope: any, $uibModalInstance: any): void => {
                                    $scope.ok = () => {
                                        postleave();
                                        $uibModalInstance.close($scope.model);
                                    };
                                }],
                            });
                        } else {
                            postleave();
                        }
                    }
                };
            }
        ],
        });
    }

    // modal used to add late arrivals to an employees profile
    public latenessModal(): void {
        const that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.lateness = {};
                $scope.lateness.reminder = false;
                $scope.lateness.minTime = new Date (new Date().toDateString() + ' ' + that.org.extra.details.work_hours_start);
                $scope.lateness.maxTime = new Date (new Date().toDateString() + ' ' + that.org.extra.details.work_hours_end);
                $scope.lateness.reason = '';
                $scope.lateness.arrivalDate = new Date();
                $scope.lateness.expectedArrivalTime = that.org.extra.details.work_hours_start;

                // if work hours have been set in org profile then populate the expected arrival time from that value
                // otherwise default to 8:00am
                if ($scope.lateness.expectedArrivalTime === undefined) {
                    $scope.lateness.reminder = true;
                    $scope.lateness.expectedArrivalTime = new Date (new Date().toDateString() + ' ' + '08:00');
                    $scope.lateness.expectedArrivalTime = moment($scope.lateness.expectedArrivalTime);
                } else {
                    $scope.lateness.expectedArrivalTime = new Date (new Date().toDateString() + ' ' + that.org.extra.details.work_hours_start);
                    $scope.lateness.expectedArrivalTime = moment($scope.lateness.expectedArrivalTime);
                }

                // parse date into correct format for the dropdown/timepicker in the modal
                let timeToReturn: Date = new Date();
                timeToReturn.setMilliseconds(Math.round(timeToReturn.getMilliseconds() / 1000) * 1000);
                timeToReturn.setSeconds(Math.round(timeToReturn.getSeconds() / 60) * 60);
                timeToReturn.setMinutes(Math.round(timeToReturn.getMinutes() / 15) * 15);
                $scope.lateness.arrivalTime = moment(timeToReturn);

                // submission function for new late arrival entry
                $scope.createLateEntry = () => {
                    let dateObj: Date = new Date($scope.lateness.arrivalTime);
                    let momentObj: Moment = moment(dateObj);
                    let momentString: string = momentObj.format('HH:mm:ss');

                    let dateObj2: Date = new Date($scope.lateness.expectedArrivalTime);
                    let momentObj2: Moment = moment(dateObj2);
                    let momentString2: string = momentObj2.format('HH:mm:ss');
                    let lateArrivalUser: any = that.User.getCurrentUser().userData;
                    let lateReason: string = $scope.lateness.reason;
                    let lateArrivalDate: Date = $scope.lateness.arrivalDate;

                    // parse into correct format for the service and add new entry
                    that.Employee.createLateEntry(that.employee, lateArrivalUser, lateArrivalDate, momentString2, momentString, lateReason).then(() => {
                        that.processLateArrivals();
                        that.toaster.pop('success', 'Success', 'Late entry successfully added');
                        that.emitEvent('employee.profile.late_arrivals.add');
                    }, () => {
                        that.toaster.pop('error', 'Server error', 'Please try again later');
                    });
                };
            }],
            templateUrl: '/static/templates/employee/late_arrival_modal.html'
        });
    }

    // modal for deleting late arrivals
    public delete_arrival_modal(arrival: any): void {
        const empl: any = this.employee;
        const that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = empl.displayname;
                $scope.modalDetail = 'This late arrival entry will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete late arrival';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.Employee.delete_arrival(empl, arrival)
                    .then(() => {

                            // mark local arrival as deleted
                            for (var i: number = 0; i < that.lateArrivals.length; i++) {
                                if (that.lateArrivals[i] === arrival) {
                                    that.lateArrivals[i].deleted = true;
                                }
                            }
                            this.Employee.loadEmployee(empl.id).then((response2: Restangular.IResponse) => {
                                this.employee = response2;
                                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                                this.toaster.pop('success', 'Success', 'Late arrival entry deleted successfully.');
                                this.emitEvent('employee.profile.late_arrivals.add');
                            });
                        }, () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Error', 'There was an error processing your request');
                    }
                );
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public delete_doc_modal(doc_index: number): void {
        const empl: any = this.employee;
        const that: this = this;
        const doc: any = empl.extra['employment']['documents'][doc_index];
        let doc_title: string = doc.type;
        if (doc.type === 'Other Documents') {
            doc_title = doc.name;
        }

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', 
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + doc_title;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.emitEvent('employee.profile.employment.doc.'+doc.type+'.delete');
                empl.extra['employment']['documents'].splice(doc_index, 1);
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public delete_review_doc_modal(doc_index: number): void {
        const empl: any = this.employee;
        const that: this = this;
        const doc: any = empl.extra['employment']['review_documents'][doc_index];

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete performance review';
                    $scope.modalDetail = 'This performance review will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete review';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.emitEvent('employee.profile.employment.review_doc.delete');
                empl.extra['employment']['review_documents'].splice(doc_index, 1);
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public delete_contract(doc_index: number): void {
        const empl: any = this.employee;
        const that: this = this;
        let doc_title: string = 'Contract Copy';

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + doc_title;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                // this.emitEvent('employee.profile.employment.doc.'+doc.type+'.delete');
                delete empl.extra['employment']['contract']['file'];
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public deleteVaccineRecord(doc_index: number): void {
        const empl: any = this.employee;
        let doc_title: string = 'Vaccination Record';

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + doc_title;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                delete empl.extra['personal']['health']['covid_vaccination_certificate'];
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }


    public editSalaryHistory = (salary: any) => {
        const that: any = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): any {
                $scope.model = salary
                $scope.edit = () => {
                    $uibModalInstance.close($scope.model);
                }
            }],

            templateUrl: '/static/templates/modals/salary_change_edit_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.Employee.updateSalary(result).then((result) => {
                    const { status } = result;
                    if (status === 200) {
                        this.save_page();
                        this.load();
                    } else if (status === 403) {
                        this.toaster.pop('warning', 'Salary change not updated');
                    } else {
                        this.toaster.pop('error', 'Server error', 'Please try again later');
                    }
                });
            } else {
                this.toaster.pop('warning', 'Salary has not been updated');
            }
        });
    };

    public delete_salary_change_modal(salary_change): void {
        const empl: any = this.employee;
        const that: this = this;

        var currency = "AED";

        if (this.org.extra.details.currency) {
            currency = this.org.extra.details.currency;
        }

        let doc_title: string = currency + (salary_change.previous_monthlysalary * 12).toString();

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + doc_title;
                    $scope.modalDetail = 'This salary change entry will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete salary change';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {

                if (!this.employee.extra.deleted_salary) {
                    this.employee.extra.deleted_salary = [];
                }

                this.employee.extra.deleted_salary.push(salary_change.id);
                this.save_page();

            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public save_leave(bin_id: string, config_key: string, config_value: number): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        this.Employee.updateLeave(this.employee.id, bin_id, config_key, config_value).then((response) => {
            this.employee = response.data;
            this.checkLoading();
            this.processLoadEmployee();
            this.toaster.pop('success', 'Success', 'Leave settings updated');

            }, () => {
            this.checkLoading();

            this.toaster.pop('error', 'Server error', 'Please try again later');
        });
    }

    public save_page(): void {
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        if (this.employee.extra.personal['nationality']) {
            // make uppercase value lowercase to account for schema
            this.employee.extra.personal['nationality'] = this.employee.extra.personal['nationality'].replace(/\w*\S/g, function (txt: string): string {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }

        let s: any = _.get(this.employee.extra, 'employment.structure');
        if (s !== undefined) {
            this.employee.extra['employment']['structure'] = _.pickBy(s, undefined);
        }

        if (this.employee.extra.personal['languages']) {
            this.employee.extra.personal['languages'] = this.employee.extra.personal['languages'].filter(Boolean);
        }

        if (this.employee.extra.employment['benefits']) {
            this.employee.extra.employment['benefits'] = this.employee.extra.employment['benefits'].filter(Boolean);
        }

        this.contract_start_date = _.get(this.employee.extra, 'leave.start_date', undefined) 
            ? new Date(this.employee.extra.leave.start_date) 
            : undefined;

        let that = this;

        this.employee.put().then((response) => {
            // Check if we need to emit an event log
            if (that.empEventName) {
                that.emitEvent(that.empEventName, that.empEventAddData);

                // Reset event data
                that.empEventName = '';
                that.empEventAddData = '';
            }
            this.employee = response;
            this.checkLoading();
            this.toaster.pop('success', 'Saved');

            // TODO: review - do we need these editing variables anymore?
            this.editing = false;
            this.editing_new = false;
            this.form_models = {};
            if (this.dependant && this.dependantIndex >= 0) {
                this.dependant = this.employee.extra.personal.dependants[this.dependantIndex];
            }
            
            if (this.add_document) {
                this.document = this.employee.extra.employment.documents[this.employee.extra.employment.documents.length - 1];
            }

            // update the avaliable filters in the employee filter controller to have anything new that has been saved in the current profile
            let availableFilters: any = this.Employee.getAvailableFilters();
            availableFilters.office.options = (this.org.extra.offices || []).map((i) =>
                ({name: i.name, value: i.name}));
            availableFilters.division.options = [].concat.apply([],
                (this.org.extra.offices || []).map((o) => (o.divisions || []))).map((i) =>
                ({name: i.name, value: i.name}));
            availableFilters.department.options = [].concat.apply([],
                (this.org.extra.offices || []).map((o) => [].concat.apply([],
                    (o.divisions || []).map((d) => (d.departments || []))))).map((i) =>
                ({name: i.name, value: i.name}));
            this.Employee.list().then((employees) => {
                var nationalities: string[] = [];
                for (var i: number = 0; i < employees.results.length; i++) {
                    let e: any = employees.results[i];
                    let n: string = e.extra.personal.nationality;
                    if (n && nationalities.indexOf(n) === -1) {
                        nationalities = nationalities.concat([n]);
                    }
                }

                availableFilters.nationality.options = nationalities.map((n) =>
                    ({name: n, value: n}));
            });

            this.Employee.setAvailableFilters(availableFilters);
            this.processLoadEmployee();
        }, 
        (response: any) => {
            this.checkLoading();
            if (response.status === 403) {
                this.toaster.pop('error', 'Access Denied', response.data.detail);
            } else if (response.status === 400) {
                this.toaster.pop('warning', 'Validation Failed', response.data[0] || response.data);
            } else {
                this.toaster.pop('error', 'Server error', 'Please, try again later');
            }
        });
    }

    // this is the upload function for uploading/updating an employees profile picture
    public upload_file(file: any, errFiles: any): void {
        let errFile: any = errFiles && errFiles[0];
        if (file) {
            this.bsLoadingOverlayService.start({referenceId: 'loader'});
            file.upload = this.Upload.upload({
                url: '/api/uploads/image',
                data: {file: file}
            });
            file.upload.then((response) => {
                this.$timeout(() => {
                    file.result = response.data;
                    var old_image: string = this.employee.extra.image;
                    this.employee.extra.image = response.data.url;
                    this.employee.put().then(() => {
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        this.toaster.pop('success', 'Saved');
                        if (this.employee.id === this.User.getUserId()) {
                            this.$scope.$root.$broadcast('profilePicChanged', {'imageUrl': this.employee.extra.image});
                        }
                    }, () => {
                        this.employee.extra.image = old_image;
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        this.toaster.pop('error', 'Error Saving Employee');
                    });
                });
            }, 
            (response) => {
                if (response.status > 0) {
                    this.toaster.pop('error', 'Image Upload Error', response.data);
                }

                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            }, 
            (evt) => {
                file.progress = Math.min(100, parseInt((100.0 * evt.loaded / evt.total).toString(), 10));
            });
        }

        if (errFile) {
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
            this.toaster.pop('error', 'Invalid File', errFile.$error + ' must be ' + errFile.$errorParam);
        }
    }

    /**
     * Check if the employee is the same that is logged in
     * @param  {string}  employeeId
     * @return {boolean}
     */
    public canDecide(employeeId: string): boolean {
        return this.User.getCurrentUser().userData.id !== employeeId;
    }

    public assign_subordinate_modal(): void {
        let superior_empl: any = this.employee;
        let subordinate: any = undefined;
        let subordinate_idx: any = -1;
        for (let sub of this.subord_candidates) {
            subordinate_idx += 1;
            if (sub.id === this.new_subordinate) {
                subordinate = sub;
                break;
            }
        }

        if (!subordinate) {
            this.toaster.pop('error', 'Error', 'There was an error processing your request');
            return;
        }

        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = subordinate.displayname;
                $scope.modalDetail = 'This employee will be assigned as a direct subordinate of ' + superior_empl.displayname + '.  Are you sure?';
                $scope.confirmButton = 'Assign Direct Subordinate';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.Employee.loadEmployee(subordinate.id).then((response: Restangular.IResponse) => {
                    this.Employee.update_superior(response, superior_empl).then(() => {
                        this.Employee.loadEmployee(superior_empl.id).then((response2: Restangular.IResponse) => {
                            this.employee = response2;
                            if (this.employee.subordinates.length === 0) {
                                this.showRowSubOrdinate = false;
                            } else {
                                this.showRowSubOrdinate = true;
                            }
                            this.new_subordinate = undefined;
                            this.loadSubOrdCandidates();
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('success', 'Success', 'Employee assigned successfully.');
                        });

                    }, 
                    () => {
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        this.toaster.pop('error', 'Error', 'There was an error processing your request');
                    });
                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public unassign_subordinate_modal(subordinate: any): void {
        let superior_empl: any = this.employee;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = subordinate.displayname;
                $scope.modalDetail = 'This employee will be unassigned as a direct subordinate of ' 
                    + superior_empl.displayname 
                    + '.  Are you sure?';
                $scope.confirmButton = 'Unassign Direct Subordinate';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };

                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.Employee.loadEmployee(subordinate.id).then((response: Restangular.IResponse) => {
                    this.Employee.update_superior(response, undefined).then(() => {
                        this.Employee.loadEmployee(superior_empl.id).then((response2: Restangular.IResponse) => {
                            this.employee = response2;
                            if (this.employee.subordinates.length === 0) {
                                this.showRowSubOrdinate = false;
                            } else {
                                this.showRowSubOrdinate = true;
                            }
                            this.loadSubOrdCandidates();
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('success', 'Success', 'Employee unassigned successfully.');
                        });
                    }, 
                    () => {
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        this.toaster.pop('error', 'Error', 'There was an error processing your request');
                    });
                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public createNote(): void {
        if (this.newNote) {
            this.Employee.createNote(this.employee, this.User.getCurrentUser().userData, this.newNote).then(() => {
                this.emitEvent('employee.profile.notes.add');
                this.toaster.pop('success', 'Success', 'Note successfully added');
                this.newNote = '';
            }, () => {
                this.toaster.pop('error', 'Server error', 'Please try again later');
            });
        }
    }

    public delete_note_modal(note: any): void {
        let empl: any = this.employee;
        let that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = empl.displayname;
                $scope.modalDetail = 'The note item will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete Note';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };

                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.Employee.loadEmployee(empl.id).then((response: Restangular.IResponse) => {
                    this.Employee.deleteNote(note, this.employee, this.User.getCurrentUser().userData).then(() => {
                        this.emitEvent('employee.profile.notes.delete');
                        this.toaster.pop('success', 'Success', 'Note successfully deleted');
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    }, () => {
                        this.toaster.pop('error', 'Server error', 'Please try again later');
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    });
                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public delete_leave_modal(leave: any): void {
        let empl: any = this.employee;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = empl.displayname;
                let leave_desc: string = moment(leave.start_date).format('DD-MM-YYYY') + ' to ' + moment(leave.end_date).format('DD-MM-YYYY');
                if (leave.note) {
                    leave_desc += ': ' + leave.note;
                }

                $scope.modalDetail = 'The leave item [' + leave_desc + ']  will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete leave';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };

                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });

        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.Employee.loadEmployee(empl.id).then((response: Restangular.IResponse) => {
                    this.Employee.delete_leave(response, leave.id).then(() => {
                        this.Employee.loadEmployee(empl.id).then((response2: Restangular.IResponse) => {
                            this.employee = response2;
                            this.loadSubOrdCandidates();
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('success', 'Success', 'Leave deleted successfully.');
                            this.emitEvent('employee.profile.leave.delete', leave.type);

                        });
                    }, () => {
                        this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                        this.toaster.pop('error', 'Error', 'There was an error processing your request');
                    });
                });
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public archive_leave_modal(leave: any): void {
        let empl: any = this.employee;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', 'toaster', function ($scope: any, $uibModalInstance: any, toaster: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = empl.displayname;
                let leave_desc: string = moment(leave.start_date).format('DD-MM-YYYY') + ' to ' + moment(leave.end_date).format('DD-MM-YYYY');
                if (leave.note) {
                    leave_desc += ': ' + leave.note;
                }

                $scope.modalDetail = 'The leave item [' + leave_desc + ']  will be archived.  Are you sure?';
                $scope.confirmButton = 'Archive leave';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };

                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],

            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.Employee.loadEmployee(empl.id)
                    .then((response: Restangular.IResponse) => {
                        this.Employee.archive_leave(response, leave.id).then(() => {
                            this.Employee.loadEmployee(empl.id).then((response2: Restangular.IResponse) => {
                                this.employee = response2;
                                this.loadSubOrdCandidates();
                                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                                this.toaster.pop('success', 'Success', 'Leave archived successfully.');
                                this.emitEvent('employee.profile.leave.archive', leave.type);
                            });
                        }, 
                        () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Error', 'There was an error processing your request');
                        });
                    }
                );
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    // called when selecting a dependant from the employee dependant tab - this parses all the models with the correct data for the correct employee
    public selectDependant(index: number): void {
        this.emitEvent('employee.profile.dependants.view');
        this.dependantIndex = index;
        this.currentDependantObj = {
            name: this.employee.extra.personal.dependants[this.dependantIndex].name || this.defaultValue,
            birthDate: new Date(this.employee.extra.personal.dependants[this.dependantIndex].birth_date) || undefined,
            relation: this.employee.extra.personal.dependants[this.dependantIndex].relation || this.defaultValue,
            nationality: this.employee.extra.personal.dependants[this.dependantIndex].nationality || this.defaultValue,
            inHouseVisa: this.employee.extra.personal.dependants[this.dependantIndex].inhouse_visa || false,
            inHouseMedAid: this.employee.extra.personal.dependants[this.dependantIndex].inhouse_medical || false,
            visa: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue},
            passport: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file:  this.defaultValue},
            emiratesId: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue},
            medInsuranceCard: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue},
            tob: {
                number: undefined,
                expiryDate: undefined,
                file: this.defaultValue},
            networkList: {
                number: undefined, 
                expiryDate: undefined,
                file: this.defaultValue}
        };

        // update visa if it exists
        if (this.employee.extra.personal.dependants[this.dependantIndex].visa) {
            this.currentDependantObj.visa = {
                number: this.employee.extra.personal.dependants[this.dependantIndex].visa.number || this.defaultValue,
                expiryDate: this.employee.extra.personal.dependants[this.dependantIndex].visa.expiry_date || this.defaultValue,
                file: this.employee.extra.personal.dependants[this.dependantIndex].visa.file || this.defaultValue
            };
        }

        // passport
        if (this.employee.extra.personal.dependants[this.dependantIndex].passport) {
            this.currentDependantObj.passport = {
                number: this.employee.extra.personal.dependants[this.dependantIndex].passport.number || this.defaultValue,
                expiryDate: this.employee.extra.personal.dependants[this.dependantIndex].passport.expiry_date || this.defaultValue,
                file: this.employee.extra.personal.dependants[this.dependantIndex].passport.file || this.defaultValue
            };
        }

        // emiratesId
        if (this.employee.extra.personal.dependants[this.dependantIndex].uae_identity_card) {
            this.currentDependantObj.emiratesId = {
                number: this.employee.extra.personal.dependants[this.dependantIndex].uae_identity_card.number || this.defaultValue,
                expiryDate: this.employee.extra.personal.dependants[this.dependantIndex].uae_identity_card.expiry_date || this.defaultValue,
                file: this.employee.extra.personal.dependants[this.dependantIndex].uae_identity_card.file || this.defaultValue
            };
        }

        // med_insurance_card
        if (this.employee.extra.personal.dependants[this.dependantIndex].med_insurance_card) {
            this.currentDependantObj.medInsuranceCard = {
                number: this.employee.extra.personal.dependants[this.dependantIndex].med_insurance_card.number || this.defaultValue,
                expiryDate: this.employee.extra.personal.dependants[this.dependantIndex].med_insurance_card.expiry_date || this.defaultValue,
                file: this.employee.extra.personal.dependants[this.dependantIndex].med_insurance_card.file || this.defaultValue
            };
        }

        // tob
        if (this.employee.extra.personal.dependants[this.dependantIndex].tob) {
            this.currentDependantObj.tob.file = this.employee.extra.personal.dependants[this.dependantIndex].tob.file || this.defaultValue;
        }

        // network_list
        if (this.employee.extra.personal.dependants[this.dependantIndex].network_list) {
            this.currentDependantObj.networkList.file = this.employee.extra.personal.dependants[this.dependantIndex].network_list.file || this.defaultValue;
        }
    }   
    
    // called when adding a new employee to set the models to have the default values
    public addDependant(): void {
        this.newDependantObj = {
            name: 'Dependant',
            birthDate: this.defaultValue,
            relation: this.defaultValue,
            nationality: this.defaultValue,
            inHouseVisa: false,
            inHouseMedAid: false,
            visa: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue},
            passport: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue},
            emiratesId: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue},
            medInsuranceCard: {
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue},
            tob: {
                number: undefined,
                expiryDate: undefined,
                file: this.defaultValue},
            networkList: {
                number: undefined,
                expiryDate: undefined,
                file: this.defaultValue
            }
        };
    }

    public delete_dependant_modal(): void {
        const empl: any = this.employee;
        const that: this = this;
        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                $scope.confirmation = false;
                $scope.modalHeader =  that.currentDependantObj.name;
                $scope.modalDetail = 'This dependant will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete dependant';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                this.Employee.delete_dependant(empl, that.dependantIndex)
                    .then(() => {

                            this.Employee.loadEmployee(empl.id).then((response2: Restangular.IResponse) => {
                                this.employee = response2;
                                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                                this.toaster.pop('success', 'Success', 'Dependant deleted successfully.');
                                that.act("select", "personal", that.personal);
                                this.emitEvent('employee.profile.dependants.delete');
                            });
                        }, () => {
                            this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                            this.toaster.pop('error', 'Error', 'There was an error processing your request');
                    }
                );
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    // uploading the dependant files
    public uploadDependantCopy(): void {
        const that: this = this;
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        if (this.files) {
            Object.keys(this.files).forEach((key) => {
                if (!this.files[key]) {
                    delete this.files[key];
                }
            });
        }

        this.fields = Object.keys(this.files);
        let results: any = {};
        this.fields.map(field => {
            results[field] = '';
            this.Upload.upload({
                url: '/api/uploads/other',
                method: 'POST',
                data: {file: this.files[field]}
            }).then(
                (response) => {
                    results[field] = response.data.url;
                    delete this.files[field];
                    Object.keys(results).forEach((key) => {
                        this.files[key] = results[key];
                        switch (key) {
                            case 'visa': {
                                this.newDependantObj.visa.file = results[key];
                                this.newDependantObj.visa.expiryDate = moment(this.newDependantObj.visa.expiryDate).format('YYYY-MM-DD');
                                break;
                            }
                            case 'passport': {
                                this.newDependantObj.passport.file = results[key];
                                this.newDependantObj.passport.expiryDate = moment(this.newDependantObj.passport.expiryDate).format('YYYY-MM-DD');
                                break;
                            }
                            case 'emiratesId': {
                                this.newDependantObj.emiratesId.file = results[key];
                                this.newDependantObj.emiratesId.expiryDate = moment(this.newDependantObj.emiratesId.expiryDate).format('YYYY-MM-DD');
                                break;
                            }
                            default: {
                                this.toaster.pop('error', 'File upload error occured.', '');
                            }
                        }
                    });

                    this.setLabelFiles();
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                }, 
                () => {
                    this.errors = true;
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    this.toaster.pop('error', 'upload failed', '');
                }
            );
        }, this);
    }


    public addNewDependant(): void {
        this.uploadDependantCopy(); 
        this.newDependantObj.birthDate = moment(this.newDependantObj.birthDate).format('YYYY-MM-DD');
        let saveFormatObj: any = {};
        saveFormatObj['name'] = this.newDependantObj.name;
        saveFormatObj['relation'] = this.newDependantObj.relation;
        saveFormatObj['inhouse_visa'] = this.newDependantObj.inHouseVisa;
        saveFormatObj['inhouse_medical'] = this.newDependantObj.inHouseMedAid;
        if (this.newDependantObj.birthDate) {
            saveFormatObj['birth_date'] = this.newDependantObj.birthDate.toString();
        }

        if (this.newDependantObj.nationality) {
            saveFormatObj['nationality'] = this.newDependantObj.nationality.toString();
        }

        // save network list if specified
        if (this.newDependantObj.networkList.file.toString() !== '') {
            saveFormatObj['network_list'] = {
                file: this.newDependantObj.networkList.file.toString()
            };
        }

        // save tob if specified
        if (this.newDependantObj.tob.file.toString() !== '') {
            saveFormatObj['tob'] = {
                file: this.newDependantObj.tob.file.toString()
            };
        }

        // save passport if specified
        if (this.newDependantObj.passport.expiryDate !== '' &&
            this.newDependantObj.passport.file.toString() !== '' &&
            this.newDependantObj.passport.number.toString() !== '') {
            saveFormatObj['passport'] = {
                expiry_date: this.newDependantObj.passport.expiryDate !== '' 
                    ? moment(this.newDependantObj.passport.expiryDate).format('YYYY-MM-DD').toString() 
                    : '',
                file: this.newDependantObj.passport.file.toString(),
                number: this.newDependantObj.passport.number.toString()
            };
        }

        // save uae_identity_card if specified
        if (this.newDependantObj.emiratesId.expiryDate !== '' &&
            this.newDependantObj.emiratesId.file.toString() !== '' &&
            this.newDependantObj.emiratesId.number.toString() !== '') {

            saveFormatObj['uae_identity_card'] = {
                expiry_date: this.newDependantObj.emiratesId.expiryDate !== '' 
                    ? moment(this.newDependantObj.emiratesId.expiryDate).format('YYYY-MM-DD').toString() 
                    : '',
                file: this.newDependantObj.emiratesId.file.toString(),
                number: this.newDependantObj.emiratesId.number.toString()
            };
        }

        // save visa if specified
        if (this.newDependantObj.visa.expiryDate !== '' &&
            this.newDependantObj.visa.file.toString() !== '' &&
            this.newDependantObj.visa.number.toString() !== '') {
            saveFormatObj['visa'] = {
                expiry_date: this.newDependantObj.visa.expiryDate !== '' 
                    ? moment(this.newDependantObj.visa.expiryDate).format('YYYY-MM-DD').toString() 
                    : '',
                file: this.newDependantObj.visa.file.toString(),
                number: this.newDependantObj.visa.number.toString()
            };
        }

        // save med_insurance_card if specified
        if (this.newDependantObj.medInsuranceCard.expiryDate !== '' &&
            this.newDependantObj.medInsuranceCard.file.toString() !== '' &&
            this.newDependantObj.medInsuranceCard.number.toString() !== '') {
            saveFormatObj['med_insurance_card'] = {
                expiry_date: this.newDependantObj.medInsuranceCard.expiryDate !== '' 
                    ? moment(this.newDependantObj.medInsuranceCard.expiryDate).format('YYYY-MM-DD').toString() 
                    : '',
                file: this.newDependantObj.medInsuranceCard.file.toString(),
                number: this.newDependantObj.medInsuranceCard.number.toString()
            };
        }

        if (!this.newDependantObj.name || !this.newDependantObj.relation) {
            this.toaster.pop('warning', 'Validation Failed', 'The Name and Relation fields are required.');
            this.bsLoadingOverlayService.stop({referenceId: 'loader'});

        } else {
            this.defs['dependant'].update_list((xs) => xs.concat(saveFormatObj));
            this.selectDependant(this.employee.extra.personal.dependants.length - 1);
            this.empEventName = 'employee.profile.dependants.add';
            this.save_page();
        }
    }

    public setLabelFiles(): void {
        this.fileName.visa = (_.has(this.newDependantObj.visa, 'file'))
            ? this.parseFileName(this.newDependantObj.visa.file) : undefined;

        this.fileName.passport = (_.has(this.newDependantObj.passport, 'file'))
            ? this.parseFileName(this.newDependantObj.passport.file) : undefined;

        this.fileName.emiratesId = (_.has(this.newDependantObj.emiratesId, 'file'))
            ? this.parseFileName(this.newDependantObj.emiratesId.file) : undefined;
    }

    public parseFileName(input: any): string {
        if (!_.isEmpty(input)) {
            return decodeURI(input.substring(input.lastIndexOf('/') + 1));   
        }
    }

    public documentEditModal(editing: string, obj: any): void  {

        // check what document type is being edited
        if (editing === 'visa') {
            this.docType = 'visa';
            this.docLabel = 'Visa';
        } else if (editing === 'passport') {
            this.docType = 'passport';
            this.docLabel = 'Passport';
        } else if (editing === 'emiratesId') {
            this.docType = 'emiratesId';
            this.docLabel = 'Emirates ID';
        } else if (editing === 'medInsuranceCard') {
            this.docType = 'medInsuranceCard';
            this.docLabel = 'Medical Insurance Card';
        } else if (editing === 'tob') {
            this.docType = 'tob';
            this.docLabel = 'Table of Benefits';
        } else if (editing === 'networkList') {
            this.docType = 'networkList';
            this.docLabel = 'Network List';
        } else if (editing === 'close') {

            // closing the dialog
            return;
        } else {
            this.docType = '';
            this.docLabel = '';
        }

        // assign the right object to the right model
        this.docObj.name = this[obj].name;
        this.docObj.number = this[obj][this.docType].number;
        this.docObj.expiryDate = this[obj][this.docType].expiryDate;
        if (obj === 'currentDependantObj') {
            this.docObj.file  = this[obj][this.docType].file;
            this.fileDirModel.fileName = this.parseFileName(this[obj][this.docType].file);
        } else {
            this.docObj.file = '';
            this.fileDirModel.fileName = '';
        }
    }

    public documentDeleteModal(editing: string, obj: any): void {
        // check what document type is being edited
        if (editing === 'visa') {
            this.docType = 'visa';
            this.docKey = 'visa';
            this.docLabel = 'Visa';
        } else if (editing === 'passport') {
            this.docType = 'passport';
            this.docKey = 'passport';
            this.docLabel = 'Passport';
        } else if (editing === 'emiratesId') {
            this.docType = 'emiratesId';
            this.docKey = 'uae_identity_card';
            this.docLabel = 'Emirates ID';
        } else if (editing === 'medInsuranceCard') {
            this.docType = 'medInsuranceCard';
            this.docKey = 'med_insurance_card';
            this.docLabel = 'Medical Insurance Card';
        } else if (editing === 'tob') {
            this.docType = 'tob';
            this.docKey = 'tob';
            this.docLabel = 'Table of Benefits';
        } else if (editing === 'networkList') {
            this.docType = 'networkList';
            this.docKey = 'network_list';
            this.docLabel = 'Network List';
        } else if (editing === 'close') {

            // closing the dialog
            return;
        } else {
            this.docType = '';
            this.docLabel = '';
        }

        const empl: any = this.employee;
        const that: this = this;
        // assign the right object to the right model
        this.docObj.name = this[obj].name;
        this.docObj.number = this[obj][this.docType].number;
        this.docObj.expiryDate = this[obj][this.docType].expiryDate;
        if (obj === 'currentDependantObj') {
            this.docObj.file  = this[obj][this.docType].file;
            this.fileDirModel.fileName = this.parseFileName(this[obj][this.docType].file);
        } else {
            this.docObj.file = '';
            this.fileDirModel.fileName = '';
        }

        let modalInstance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/confirmation_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster',
                function ($scope: any, $uibModalInstance: any, toaster: any): void {
                    $scope.confirmation = false;
                    $scope.modalHeader = 'Delete: ' + that.docLabel;
                    $scope.modalDetail = 'This document will be deleted.  Are you sure?';
                    $scope.confirmButton = 'Delete document';
                    $scope.cancelButton = 'Cancel';
                    $scope.confirm = () => {
                        $scope.confirmation = true;
                        $uibModalInstance.close($scope.confirmation);
                    };
                    $scope.cancel = () => {
                        $scope.confirmation = false;
                        $uibModalInstance.close($scope.confirmation);
                    };
                }
            ],
        });

        modalInstance.result.then((result) => {
            if (result) {
                delete empl.extra.personal.dependants[this.dependantIndex][this.docKey];
                this[obj][this.docType] = {
                    number: this.defaultValue,
                    expiryDate: this.defaultValue,
                    file: this.defaultValue
                };
                this.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }


    public saveDocumentEdit(model: string): void {

        /**
         * saves the modal details. 
         * add the date of expiry, type and link here then pass 
         * to save function along with normal savetoApi data.
         */
        if (this.employee.extra.personal.dependants === undefined) {
            this.employee.extra.personal.depedants = {};
        }

        let dependant: any = this.employee.extra.personal.dependants[this.dependantIndex];
        switch (model) {
            case 'visa': {
                if (!dependant.visa) {
                    dependant.visa = {};
                }
                if (this.docObj.number !== '') {
                    this.newDependantObj.visa.number 
                        = this.currentDependantObj.visa.number 
                        = dependant.visa.number 
                        = this.docObj.number;
                }
                if (this.docObj.expiryDate !== '') {
                    this.newDependantObj.visa.expiryDate 
                        = this.currentDependantObj.visa.expiryDate 
                        = dependant.visa.expiry_date 
                        = moment(this.docObj.expiryDate).format('YYYY-MM-DD');
                }
                if (this.docObj.file !== '') {
                    this.newDependantObj.visa.file 
                        = this.currentDependantObj.visa.file 
                        = dependant.visa.file 
                        = this.docObj.file;
                }

                this.empEventName = 'employee.profile.dependants.doc.visa.save';
                break;
            }
            case 'passport': {
                if (!dependant.passport) {
                    dependant.passport = {};
                }
                if (this.docObj.number !== '') {
                    this.newDependantObj.passport.number 
                        = this.currentDependantObj.passport.number 
                        = dependant.passport.number 
                        = this.docObj.number;
                }
                if (this.docObj.expiryDate !== '') {
                    this.newDependantObj.passport.expiryDate 
                        = this.currentDependantObj.passport.expiryDate 
                        = dependant.passport.expiry_date 
                        = moment(this.docObj.expiryDate).format('YYYY-MM-DD');
                }
                if (this.docObj.file !== '') {
                    this.newDependantObj.passport.file 
                        = this.currentDependantObj.passport.file 
                        = dependant.passport.file 
                        = this.docObj.file;
                }
              this.empEventName = 'employee.profile.dependants.doc.passport.save';
              break;
            }
            case 'emiratesId': {
                if (!dependant.uae_identity_card) {
                    dependant.uae_identity_card = {};
                }

                if (this.docObj.number !== '') {
                    this.newDependantObj.emiratesId.number 
                        = this.currentDependantObj.emiratesId.number 
                        = dependant.uae_identity_card.number 
                        = this.docObj.number;
                }

                if (this.docObj.expiryDate !== '') {
                    this.newDependantObj.emiratesId.expiryDate 
                        = this.currentDependantObj.emiratesId.expiryDate 
                        = dependant.uae_identity_card.expiry_date 
                        = moment(this.docObj.expiryDate).format('YYYY-MM-DD');
                }

                if (this.docObj.file !== '') {
                    this.newDependantObj.emiratesId.file
                        = this.currentDependantObj.emiratesId.file 
                        = dependant.uae_identity_card.file 
                        = this.docObj.file;
                }

                this.empEventName = 'employee.profile.dependants.doc.emirates_id.save';
                break;
            }
            case 'medInsuranceCard': {
                if (!dependant.med_insurance_card) {
                    dependant.med_insurance_card = {};
                }

                if (this.docObj.number !== '') {
                    this.newDependantObj.medInsuranceCard.number 
                        = this.currentDependantObj.medInsuranceCard.number 
                        = dependant.med_insurance_card.number
                        = this.docObj.number;
                }

                if (this.docObj.expiryDate !== '') {
                    this.newDependantObj.medInsuranceCard.expiryDate 
                        = this.currentDependantObj.medInsuranceCard.expiryDate 
                        = dependant.med_insurance_card.expiry_date 
                        = moment(this.docObj.expiryDate).format('YYYY-MM-DD');
                }

                if (this.docObj.file !== '') {
                    this.newDependantObj.medInsuranceCard.file 
                        = this.currentDependantObj.medInsuranceCard.file 
                        = dependant.med_insurance_card.file 
                        = this.docObj.file;
                }

                this.empEventName = 'employee.profile.dependants.doc.medical_insurance_card.save';
                break;
            }
            case 'tob': {
                if (!dependant.tob) {
                    dependant.tob = {};
                }

                if (this.docObj.file !== '') {
                    this.newDependantObj.tob.file 
                        = this.currentDependantObj.tob.file 
                        = dependant.tob.file 
                        = this.docObj.file;
                }

                this.empEventName = 'employee.profile.dependants.doc.tob.save';
                break;
            }
            case 'networkList': {
                if (!dependant.network_list) {
                    dependant.network_list = {};
                }

                if (this.docObj.file !== '') {
                    this.newDependantObj.networkList.file 
                        = this.currentDependantObj.networkList.file 
                        = dependant.network_list.file 
                        = this.docObj.file;
                }
                this.empEventName = 'employee.profile.dependants.doc.network_list.save';
                break;
            }
            default: {
                break;
            }
        }

        this.save_page();
    }

    public saveEmployeeDocumentEdit(model: any): void {
        /**
         * saves the modal details.
         * add the date of expiry, type and link here then pass 
         * to save function along with normal savetoApi data.
         */
        if (!this.employee.extra.employment.documents) {
            this.employee.extra.employment.documents = [];
        }

        let empDocs: any = this.employee.extra.employment.documents;
        let ldocObj: any = undefined;

        if (model.docIndex >= 0) {
            ldocObj = empDocs[model.docIndex];
        } else {
            ldocObj = {
                type: model.type
            };

            empDocs.push(ldocObj);
        }
        // update document
        if (model.number !== '') {
            ldocObj.number = model.number;
        }

        if (model.name !== '') {
            ldocObj.name = model.name;
        }

        if (model.expiryDate !== '') {
            ldocObj.expiry_date = moment(model.expiryDate).format('YYYY-MM-DD');
        }

        if (model.file && model.file !== '') {
            ldocObj.file = this.docObj.file;
        }

        this.empEventName = 'employee.profile.employment.doc.' + model.type + '.' + model.action;

        this.save_page();
    }

    public saveReviewDocumentEdit(model: any): void {
        /**
         * saves the modal details.
         * add the date of expiry, type and link here then pass
         * to save function along with normal savetoApi data.
         */
        if (!this.employee.extra.employment.review_documents) {
            this.employee.extra.employment.review_documents = [];
        }

        let reviewDocs: any = this.employee.extra.employment.review_documents;
        let ldocObj: any = {};
        if (model.docIndex >= 0) {
            ldocObj = reviewDocs[model.docIndex];
        } else {
            reviewDocs.push(ldocObj);
        }

        if (model.description !== '') {
            ldocObj.description = model.description;
        }

        if (model.reviewDate !== '') {
            ldocObj.review_date = moment(model.reviewDate).format('YYYY-MM-DD');
        }

        if (model.file && model.file !== '') {
            ldocObj.file = this.reviewDocObj.file;
        }

        this.empEventName = 'employee.profile.employment.review_doc.' + model.action;

        this.save_page();
    }

    // upload function for all ILE files
    public uploadILEFiles = function(params: any): void {
        const that: any = this;        
        this.bsLoadingOverlayService.start({referenceId: 'loader'});
        let file: any = params.new;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                if (params.fileType === 'leave_process') {
                    this.leave_process.file = response.data.url;
                } else {
                    that.docObj.file = response.data.url;
                    that.fileDirModel.fileName = that.parseFileName(that.docObj.file); 
                    this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                    let newParams: any = {
                        model: params.fileType,
                        new: response.data.url,
                        old: params.old
                    };
                    this.inlineApiData = {
                        employeeId: this.employee.id,
                        fieldName: params.fileType,

                        // TODO: this needs to be cleared out and linked to the current object.
                        currentValue: params.old,
                        newValue : response.data.url,
                        employeeDataVersionId: 'still to fillout',
                        model: params.fileType
                    };

                    this.inlineEditingSave(newParams);
                }
            },
            (response) => {
                this.bsLoadingOverlayService.stop({referenceId: 'loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };

    public deleteUpload = function(params: any): void {

        // this needs to be replaced by the actual 
        this.fileDirModel.fileLink = undefined;
        this.fileDirModel.fileName = 'Select a file';
    };

    public saveLeaveEdit = function(args: any): void {
        let model = args.model.split('.')[1];
        let leaveType = args.leaveType;
        let newValue = args.new;

        let newArgs = {
            old: args.old,
            new: args.new,
            model: 'C.currentLeaveProfile.' + leaveType
        };

        switch (model) {
            case 'leave_per_year':
                newArgs.model += 'LeavePerYear';
                break;
            case 'leave_adjustment':
                newArgs.model += 'LeaveAdjustment';
                break;
        }
        this.save_leave(args.bin_id, model, newValue);
        // this.inlineEditingSave(newArgs);
    };

    public inlineEditingSave = function(params: any): void {

        /**
         * this will then have to implement all the calling of the service 
         * and sending the data that was changed to the api.
         */
        this.inlineApiData = {
            id : this.org.id,
            fieldName: params.model,
            currentValue: params.old,
            newValue: params.new,
            dataVersionId: 'still to fillout'
        };

        // check if we should update
        let model: any = params.model;
        let pageObj: any = model.split('.')[1];
        if (model.startsWith('C.' + pageObj + '.')) {
            model = model.substr(('C.' + pageObj + '.').length);
        }

        if (this.inlineApiData.currentValue !== this.inlineApiData.newValue) {
            switch (pageObj) {
                case 'currentUserProfile': {
                    this.savePersonal(model, pageObj);
                    break;
                }
                case 'currentDependantObj': {
                    this.saveDepedant(model, pageObj);
                    break;
                }
                case 'currentEmploymentProfile': {
                    this.saveEmployment(model, pageObj);
                    break;
                }
                case 'currentPayrollProfile': {
                    this.savePayroll(model, pageObj);
                    break;
                }
                case 'currentLeaveProfile': {
                    this.saveLeave(model, pageObj);
                    break;
                }
                case 'employeeOffice': 
                case 'employeeDivision':
                case 'employeeDepartment': {
                    this.saveStructure(model, pageObj);
                    break;
                }
                default: {
                    break;
                }
            }
        }
    };

    public savePersonal(model: string, pageObj: any): void {
        switch (model) {
            case 'firstName': {
                this.employee.extra.personal.first_name = this.inlineApiData.newValue;
                break;
            }
            case 'lastName': {
                this.employee.extra.personal.last_name  = this.inlineApiData.newValue;
                break;
            }
            case 'birthDate': {
                this.employee.extra.personal.birth_date  = moment(this.inlineApiData.newValue).format('YYYY-MM-DD');
                break;
            }
            case 'gender': {
                this.employee.extra.personal.gender = this.inlineApiData.newValue;
                break;
            }
            case 'maritalStatus': {
                this.employee.extra.personal.marital_status = this.inlineApiData.newValue;
                break;
            }
            case 'religion': {
                this.employee.extra.personal.religion = this.inlineApiData.newValue;
                break;
            }
            case 'nationality': {
                this.employee.extra.personal.nationality  = this.inlineApiData.newValue;
                break;
            }
            case 'languages': {
                this.employee.extra.personal.languages = this.inlineApiData.newValue;
                break;
            }
            case 'homeAddress': {
                this.employee.extra.personal.contact.home.address = this.inlineApiData.newValue;
                break;
            }
            case 'homePhoneNumber': {
                this.employee.extra.personal.contact.home.phone_number = this.inlineApiData.newValue;
                break;
            }
            case 'homeEmail': {
                this.employee.extra.personal.contact.home.email = this.inlineApiData.newValue;
                break;
            }
            case 'workAddress': {
                this.employee.extra.personal.contact.work.address = this.inlineApiData.newValue;
                break;
            }
            case 'workPhoneNumber': {
                this.employee.extra.personal.contact.work.phone_number = this.inlineApiData.newValue;
                break;
            }
            case 'workMobile': {
                this.employee.extra.personal.contact.work.mobile_number = this.inlineApiData.newValue;
                break;
            }
            case 'workEmail': {
                this.employee.extra.personal.contact.work.email = this.inlineApiData.newValue;
                break;
            }
            case 'emergencyContactName': {
                this.employee.extra.personal.contact.emergency.name = this.inlineApiData.newValue;
                break;
            }
            case 'emergencyContactAddress': {
                this.employee.extra.personal.contact.emergency.address = this.inlineApiData.newValue;
                break;
            }
            case 'emergencyContactPhoneNumber': {
                this.employee.extra.personal.contact.emergency.phone_number = this.inlineApiData.newValue;
                break;
            }
            case 'emergencyContactRelation': {
                this.employee.extra.personal.contact.emergency.relation = this.inlineApiData.newValue;
                break;
            }
            case 'medicalRecordNumber': {
                this.employee.extra.personal.health.medical_record_number = this.inlineApiData.newValue;
                break;
            }
            case 'covidVaccinationReceived': {
                this.employee.extra.personal.health.covid_vaccination_received = this.inlineApiData.newValue;
                break;
            }
            case 'covidSecondVaccinationDate': {
                this.employee.extra.personal.health.covid_vaccination_second_date = this.inlineApiData.newValue;
                break;
            }
            case 'covidVaccinationCertificate': {
                if (this.employee.extra.personal.health.covid_vaccination_certificate !== '') {
                    this.employee.extra.personal.health.covid_vaccination_received = true;
                }

                this.employee.extra.personal.health.covid_vaccination_certificate = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public saveDepedant(model: string, pageObj: any): void {
        switch (model) {
            case 'name': {
                this.employee.extra.personal.dependants[this.dependantIndex].name = this.inlineApiData.newValue;
                break;
            }
            case 'birthDate': {
                this.employee.extra.personal.dependants[this.dependantIndex].birth_date = moment(this.inlineApiData.newValue).format('YYYY-MM-DD');
                break;
            }
            case 'relation': {
                this.employee.extra.personal.dependants[this.dependantIndex].relation = this.inlineApiData.newValue;
                break;
            }
            case 'nationality': {
                this.employee.extra.personal.dependants[this.dependantIndex].nationality = this.inlineApiData.newValue;
                break;
            }
            case 'inHouseVisa': {
                this.employee.extra.personal.dependants[this.dependantIndex].inhouse_visa = this.inlineApiData.newValue;
                break;
            }
            case 'inHouseMedAid': {
                this.employee.extra.personal.dependants[this.dependantIndex].inhouse_medical = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public saveEmployment(model: string, pageObj: any): void {
        switch (model) {
            case 'superior': {
                if (this.inlineApiData.newValue.id) {
                    this.employee.superior = {
                        displayname: this.inlineApiData.newValue.name,
                        id: this.inlineApiData.newValue.id,
                        url: this.inlineApiData.newValue.url
                    };
                } else {
                    this.employee.superior = undefined;
                    this.inlineApiData.newValue = undefined;
                    this.currentEmploymentProfile.superior = undefined;
                }                
                
                break;
            }
            case 'jobTitle': {
                this.employee.extra.employment.title = this.inlineApiData.newValue;
                break;
            }
            case 'startDate': {
                this.employee.extra.employment.start_date = this.inlineApiData.newValue;
                break;
            }
            case 'endDate': {
                this.employee.extra.employment.end_date = this.inlineApiData.newValue;
                break;
            }
            case 'userRole': {
                
                // reassign the user-facing role names to backend clearance names
                switch (this.inlineApiData.newValue) {
                    case('HR Manager'): {
                        this.inlineApiData.newValue = 'admin';
                        break;
                    }
                    case('HR Administrator'): {
                        this.inlineApiData.newValue = 'edit';
                        break;
                    }
                    case('C - Level'): {
                        this.inlineApiData.newValue = 'audit';
                        break;
                    }
                    default: {
                        this.inlineApiData.newValue = '';
                        break;
                    }
                }

                this.employee.user.clearance = this.inlineApiData.newValue;
                break;
            }
            case 'workWeek': {
                this.employee.extra.leave.work_week_index = this.inlineApiData.newValue;
                break;
            }
            case 'bankName': {
                this.employee.extra.employment.bank_account.bank_name = this.inlineApiData.newValue;
                break;
            }
            case 'bankAddress': {
                this.employee.extra.employment.bank_account.bank_address = this.inlineApiData.newValue;
                break;
            }
            case 'routingCode': {
                this.employee.extra.employment.bank_account.bank_route = this.inlineApiData.newValue;
                break;
            }
            case 'accountNumber': {
                this.employee.extra.employment.bank_account.account_number = this.inlineApiData.newValue;
                break;
            }
            case 'ibanNumber': {
                this.employee.extra.employment.bank_account.iban_number = this.inlineApiData.newValue;
                break;
            }
            case 'accountName': {
                this.employee.extra.employment.bank_account.account_name = this.inlineApiData.newValue;
                break;
            }
            case 'businessLicence': {
                this.employee.extra.employment.contract.business_licence = this.inlineApiData.newValue;
                break;
            }
            case 'contractType': {
                this.employee.extra.employment.contract.contract_type = (this.inlineApiData.newValue).toLowerCase();
                break;
            }
            case 'contractNumber': {
                this.employee.extra.employment.contract.number = this.inlineApiData.newValue;
                break;
            }
            case 'contractStartDate': {
                this.employee.extra.employment.contract.start_date = this.inlineApiData.newValue;
                break;
            }
            case 'contractEndDate': {
                this.employee.extra.employment.contract.end_date = this.inlineApiData.newValue;
                break;
            }
            case 'employmentFile': {
                
                // check that this is sending through just the file link
                this.employee.extra.employment.contract.file = this.inlineApiData.newValue;
                break;
            }
            default: {
                break;
            }
        }

        if (model) {
            if (model !== 'superior') {
                this[pageObj][model] = this.inlineApiData.newValue;
                this.save_page();
            }

            if (model === 'superior') {

                // dont reassign the superior because that happens elsewhere above 
                this.save_page();    
            }  
        }
    }

    public savePayroll(model: string, pageObj: any): void {
        switch (model) {
            case 'monthlySalaryIL': {
                this.employee.monthlysalary = this.inlineApiData.newValue;
                this.empEventName = 'employee.profile.payroll.salary.edit';
                break;
            }
            // FIXME: Is this still used?
            case 'C.employeeBenfits': {
                this.employee.extra.employment.benefits = this.inlineApiData.newValue;
                break;
            }
            case 'benefitsInLine': {
                this.employee.extra.employment.benefits = this.inlineApiData.newValue;
                this.empEventName = 'employee.profile.payroll.benefits.edit';
                break;
            }
            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public saveLeave(model: string, pageObj: any): void {
        if (this.employee.extra.leave === undefined) {
            this.employee.extra.leave = {};
        }

        switch (model) {
            case 'startDate': {
                this.employee.extra.leave.start_date = this.inlineApiData.newValue;
                break;
            }
            case 'paidLeavePerYear': {
                this.employee.extra.leave.paid_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'paidLeaveCarriedForward': {
                this.employee.extra.leave.paid_leave_carried_forward = +this.inlineApiData.newValue;
                break;
            }
            case 'paidLeaveAdjustment': {
                this.employee.extra.leave.paid_leave_adjustment = +this.inlineApiData.newValue;
                break;
            }

            case 'sickLeavePerYear': {
                this.employee.extra.leave.sick_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'sickLeaveCarriedForward': {
                this.employee.extra.leave.sick_leave_carried_forward = +this.inlineApiData.newValue;
                break;
            }

            case 'maternityLeavePerYear': {
                this.employee.extra.leave.maternity_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'maternityLeaveCarriedForward': {
                this.employee.extra.leave.maternity_leave_carried_forward = +this.inlineApiData.newValue;
                break;
            }
            case 'maternityLeaveAdjustment': {
                this.employee.extra.leave.maternity_leave_adjustment = +this.inlineApiData.newValue;
                break;
            }

            case 'paternityLeavePerYear': {
                this.employee.extra.leave.paternity_leave_days_per_year = +this.inlineApiData.newValue;
                break;
            }
            case 'paternityLeaveCarriedForward': {
                this.employee.extra.leave.paternity_leave_carried_forward = +this.inlineApiData.newValue;
                break;
            }
            case 'paternityLeaveAdjustment': {
                this.employee.extra.leave.paternity_leave_adjustment = +this.inlineApiData.newValue;
                break;
            }

            default: {
                break;
            }
        }

        this[pageObj][model] = this.inlineApiData.newValue;
        this.save_page();
    }

    public saveStructure(model: any, pageObj: any): void {
        switch (pageObj) {
            case 'employeeOffice': {
                this.employee.extra.employment.structure = {
                    office: this.employeeOffice
                };

                break;
            }
            case 'employeeDivision': {
                this.employee.extra.employment.structure = {
                    office: this.employeeOffice,
                    division: this.employeeDivision
                };

                break;
            }
            case 'employeeDepartment': {
                this.employee.extra.employment.structure = {
                    office: this.employeeOffice,
                    division: this.employeeDivision,
                    department: this.employeeDepartment,
                };

                break;
            }
            default: {
                break;
            }
        }

        this.save_page();
    }

    public employmentDocumentEdit(index: any): void {
        if (index === 'new') {
            this.docObj = {
                docIndex: -1,
                name: this.defaultValue,
                type: this.defaultValue,
                number: this.defaultValue,
                expiryDate: this.defaultValue,
                file: this.defaultValue,
                action: 'add'
            };
        this.fileDirModel.fileName = 'Select a file';
        this.fileDirModel.fileLink =  undefined;

        } else {
            let docArr: any = this.employee.extra.employment.documents;
            let docType: any;
            let docName: any;

            // account for documents that are not of a specific type
            if (docArr[index].type === 'Other Documents') {
                docType = docArr[index].type;
                docName = docArr[index].name;
            } else {
                docType = docArr[index].type;
                docName = this.defaultValue;
            }

            this.docObj = {
                docIndex: index,
                name: docName,
                type: docType,
                number: docArr[index].number,
                expiryDate: docArr[index].expiry_date,
                file: docArr[index].file,
                action: 'edit'
            };

            this.fileDirModel.fileName = 'Select a file';
            this.fileDirModel.fileLink =  undefined;

            this.isPassportUpload = true;
        }
    }


    public reviewDocumentEdit(index: any): void {
        if (index === 'new') {
            this.reviewDocObj = {
                docIndex: -1,
                description: this.defaultValue,
                reviewDate: this.defaultValue,
                file: this.defaultValue,
                action: 'add'
            };
        this.fileDirModel.fileName = 'Select a file';
        this.fileDirModel.fileLink =  undefined;

        } else {
            let docArr: any = this.employee.extra.employment.review_documents;

            this.reviewDocObj = {
                docIndex: index,
                description: docArr[index].description,
                reviewDate: docArr[index].review_date,
                file: docArr[index].file,
                action: 'edit'
            };


            this.fileDirModel.fileName = 'Select a file';
            this.fileDirModel.fileLink =  undefined;

            this.isPassportUpload = true;
        }
    }



    public uploadDocModalFiles = function(params: any): void {
        const that: any = this;        
        this.bsLoadingOverlayService.start({referenceId: 'doc-loader'});
        let file: any = params.new;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                that.docObj.file = response.data.url;
                that.fileDirModel.fileName = that.parseFileName(that.docObj.file);
                this.bsLoadingOverlayService.stop({referenceId: 'doc-loader'});
            },
            () => {
                this.bsLoadingOverlayService.stop({referenceId: 'doc-loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };

    public uploadReviewDocModalFiles = function(params: any): void {
        const that: any = this;
        this.bsLoadingOverlayService.start({referenceId: 'doc-loader'});
        let file: any = params.new;
        this.Upload.upload({
            url: '/api/uploads/other',
            method: 'POST',
            data: {file: file}
        }).then(
            (response) => {
                that.reviewDocObj.file = response.data.url;
                that.fileDirModel.fileName = that.parseFileName(that.docObj.file);
                this.bsLoadingOverlayService.stop({referenceId: 'doc-loader'});
            },
            () => {
                this.bsLoadingOverlayService.stop({referenceId: 'doc-loader'});
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    };

    public documentModalUpload(value: any): void {
        if (value !== true) {
            this.isPassportUpload = false;
        } else {
            this.isPassportUpload = value;
        }
    }

    public uploadPassport(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/upload_passport_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', 'bsLoadingOverlayService', 'Upload',
            ($scope, $uibModalInstance, toaster, bsLoadingOverlayService, Upload) => {
                $scope.step = 0;
                $scope.state = 'auto';
                $scope.passportData = {};
                $scope.countryList = this.personalNationality;
                $scope.file = {
                    fileName: this.defaultValue,
                    fileLink: this.defaultValue,
                    fileType: this.defaultValue,
                };
                
                $scope.details = {
                    firstNames: this.defaultValue,
                    lastName: this.defaultValue,
                    passportNumber: this.defaultValue,
                    country: this.defaultValue,
                    birthDate: this.defaultValue,
                    expiryDate: this.defaultValue,
                    file: this.defaultValue
                };

                // the accura site uses country ISO codes as a return, we use normal country names.
                $scope.UploadPassport = (params) => {    
                    let scope: any = $scope;
                    this.bsLoadingOverlayService.start({referenceId: 'passport_loader'});
                    let file: any = params.new;
                    this.Upload.upload({
                        url: '/api/uploads/passport_scan',
                        method: 'POST',
                        data: {file: file}
                    }).then(
                        (response) => {
                            scope.file.fileLink = response.data.url;
                            scope.file.fileName = that.parseFileName(scope.file.fileLink);
                            this.bsLoadingOverlayService.stop({referenceId: 'passport_loader'});
                            scope.ConfirmUpload(response);
                        },
                        (response) => {
                            this.bsLoadingOverlayService.stop({referenceId: 'passport_loader'});
                            this.toaster.pop('error', 'Upload Failed', response.data.msg);
                            $scope.step = 1;
                            $scope.state = 'auto';
                            $scope.file = {
                                fileName: this.defaultValue,
                                fileLink: this.defaultValue,
                                fileType: this.defaultValue,
                            };
                        }
                    );
                };

                $scope.ConfirmUpload = (passportData) => {
                    $scope.passportData = this.Employee.autoPassportUpload(this.employee.id, $scope.file);
                    if (passportData.status === 201) {
                        $scope.details = {
                            firstNames: passportData.data.given_names,
                            lastName: passportData.data.surname,
                            passportNumber: passportData.data.document_no,
                            country: passportData.data.country,
                            birthDate: new Date(passportData.data.date_of_birth),
                            expiryDate: new Date(passportData.data.date_of_expiry),
                            file: $scope.file
                        };

                        $scope.step = 2;
                        $scope.state = 'auto';
                    } else {
                        $scope.step = 1;
                        $scope.state = 'auto';
                    }
                };

                $scope.manualUpload = () => {
                    $scope.step = 2;
                    $scope.state = 'manual';
                };

                $scope.tryAgain = () => {
                    $scope.step = 0;
                    $scope.state = 'auto';
                };

                $scope.DeletePassport = (args) => {
                    // the logic to delete an uploaded file from the ILE edit field needs to go here 
                };

                $scope.savePassport = (params) => {

                    // add the saving here;
                    if (!this.employee.extra.employment.documents) {
                        this.employee.extra.employment.documents = [];
                    }

                    let current_passport: any = undefined;

                    // look for existing passport document
                    for (let i: number = 0; i < this.employee.extra.employment.documents.length; i++) {
                        let doc: any = this.employee.extra.employment.documents[i];
                        if (doc.type === 'Passport') {
                            current_passport = doc;
                            break;
                        }
                    }

                    if (!current_passport) {
                        current_passport = {'type': 'Passport'};
                        this.employee.extra.employment.documents.push(current_passport);
                    }

                    current_passport.file = params.file.fileLink;
                    current_passport.number = params.passportNumber;
                    current_passport.expiry_date = params.expiryDate;
                    this.save_page();
                    modal_instance.close({myData: $scope.details});                    
                };
            }],
        });

        modal_instance.result.then();
    }

    public nextCallout (params: any): any {
        if (this.checkPermission(params)) {
        } else if (!this.checkPermission(params)) {
            this.isCurrent = this.isCurrent + 1;
        } else if (params === 'all') {
            this.isCurrent = this.isCurrent + 1;
        }
    }

    public startCallouts = (state: string) => {
        if (this.isHelping) {
            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            if (state === 'profile') {
                this.isCurrent = 3;
            } else {
                this.isCurrent = 0;
            }
        }
    }

    public employeeDepartmentSave = function(params: any, key: string): void {
        switch (key) {
            case 'office': {
                this.employmentDivision = [];
                this.employeeDivision = '---';
                this.employmentDepartment = [];
                this.employeeDepartment = '---';
                this.employeeOffice = params.model;

                if (this.employeeOffice !== undefined) {
                    this.officeIndex = this.employmentOffices.indexOf(this.employeeOffice);
                    if (this.officeIndex >= 0 && this.org.extra.offices[this.officeIndex]['divisions']) {
                        for (var k: number = 0; k < this.org.extra.offices[this.officeIndex].divisions.length; k++) {
                            this.employmentDivision.push(this.org.extra.offices[this.officeIndex].divisions[k].name);
                        }
                    }
                }

                break;
            }
            case 'division': {
                this.employeeDivision = params.model;
                this.employmentDepartment = [];
                this.employeeDepartment = '---';
                if (this.employeeDivision !== undefined) {
                    this.officeIndex = this.employmentOffices.indexOf(this.employeeOffice);
                    this.divisionIndex = this.employmentDivision.indexOf(this.employeeDivision);
                    if (this.divisionIndex >= 0 && this.org.extra.offices[this.officeIndex].divisions[this.divisionIndex]['departments']) {
                        for (var l: number = 0; l < this.org.extra.offices[this.officeIndex].divisions[this.divisionIndex].departments.length; l++) {
                            this.employmentDepartment.push(this.org.extra.offices[this.officeIndex].divisions[this.divisionIndex].departments[l].name);
                        }
                    }
                }

                break;
            }
            case 'department': {
                this.employeeDepartment = params.model;
                break;
            }
            default: {
                break;
            }
        }
    };

    // following two functions are for converting the bootstrap modals into UIB modals.
    public addEditEmploymentDocuments(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/employment_document_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {});
    }

    // following two functions are for converting the bootstrap modals into UIB modals.
    public addEditReviewDocuments(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/review_document_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {});
    }


    public triggerLeaveTypeLoad (num: number): any {
        this.leaveTabSelected = num;
    }


    public addEditDependantsDocuments(): void {
        const that: this = this;
        let modal_instance: any = this.$uibModal.open({
            templateUrl: '/static/templates/modals/dependants_document_modal.html',
            controller: ['$scope', '$uibModalInstance', 'toaster', ($scope, $uibModalInstance, toaster) => {
                $scope.C = that;
            }],
        });

        modal_instance.result.then(() => {});
    }

    public emitEvent(eventName: string, eventAddData?: string): void {
        this.$scope.$emit('$EL', eventName, eventAddData);
    }

    public dateStrComparator(a: string, b:string): number {
        let dtA = Date.parse(a);
        let dtB = Date.parse(b);
        return dtA
    }

    /**
     * Can the current logged in user edit the employee data:
     *   - Yes if they have the change_employee permission
     *   - Yes if:
     *      - employee_can_edit_personal is enabled and
     *      - the use is editing/viewing their own profile
     */
    public canEmployeeOrUserEdit(): boolean {
        if (this.User.hasPermission('org.change_employee')) {
            return true;
        }

        // Check the self-edit feature
        if (this.org && this.org.extra && this.org.extra.details) {
            return this.org.extra.details.employee_can_edit_personal && this.isMe;
        }

        // Failsafe return
        return false;
    }

    public addAllowance(): void {
        this.payrollAllowanceData.allowances.push({
            description: 'New',
            monthly: 0,
            yearly: 0
        });
        // Setup default values
        if (!this.employee.extra.employment) {
            this.employee.extra.employment = {};
        }
        if (!this.employee.extra.employment.allowances) {
            this.employee.extra.employment.allowances = [];
        }

        this.employee.extra.employment.allowances.push({
            description: 'New',
            amount: 0,
        });
    }

    public addDeduction(): void {
        let current_day = moment().format('YYYY-MM-DD');
        this.payrollAllowanceData.deductions.push({
            description: 'New',
            monthly: 0,
            yearly: 0,
            valid_for: current_day
        });
        // Setup default values
        if (!this.employee.extra.employment) {
            this.employee.extra.employment = {};
        }
        if (!this.employee.extra.employment.deductions) {
            this.employee.extra.employment.deductions = [];
        }

        this.employee.extra.employment.deductions.push({
            description: 'New',
            amount: 0,
            valid_for: current_day
        });
    }

    public editAllowanceDescription(args, index): void {
        this.employee.extra.employment.allowances[index].description = args.new;
        this.save_page();
    }
    public editDeductionDescription(args, index): void {
        this.employee.extra.employment.deductions[index].description = args.new;
        this.save_page();
    }

    public editAllowanceBasic(args, index): void {
        this.employee.monthlysalary = args.new;
        this.save_page();
    }

    public editAllowanceAmount(args, index): void {
        this.employee.extra.employment.allowances[index].amount = parseInt(args.new);
        this.save_page();
    }

    public editDeductionAmount(args, index): void {
        this.employee.extra.employment.deductions[index].amount = parseInt(args.new);
        this.save_page();
    }

    public deleteAllowance(index: number): void{
        const empl: any = this.employee;
        const that: this = this;
        const allowanceItem = this.payrollAllowanceData.allowances[index];

        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = empl.displayname;
                $scope.modalDetail = 'The allowance item "' + allowanceItem.description + '" will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete allowance item';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                empl.extra.employment.allowances.splice(index, 1);
                that.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public deleteDeduction(index: number): void{
        const empl: any = this.employee;
        const that: this = this;
        const allowanceItem = this.payrollAllowanceData.deductions[index];

        let modalInstance: any = this.$uibModal.open({
            controller: ['$scope', '$uibModalInstance', function ($scope: any, $uibModalInstance: any): void {
                $scope.confirmation = false;
                $scope.modalHeader = empl.displayname;
                $scope.modalDetail = 'The deduction item "' + allowanceItem.description + '" will be deleted.  Are you sure?';
                $scope.confirmButton = 'Delete deduction item';
                $scope.cancelButton = 'Cancel';
                $scope.confirm = () => {
                    $scope.confirmation = true;
                    $uibModalInstance.close($scope.confirmation);
                };
                $scope.cancel = () => {
                    $scope.confirmation = false;
                    $uibModalInstance.close($scope.confirmation);
                };
            }],
            templateUrl: '/static/templates/modals/confirmation_modal.html'
        });
        modalInstance.result.then((result) => {
            if (result) {
                this.bsLoadingOverlayService.start({referenceId: 'loader'});
                empl.extra.employment.deductions.splice(index, 1);
                that.save_page();
            } else {
                this.toaster.pop('warning', 'Cancelled', 'No changes were made. Action cancelled by user');
            }
        });
    }

    public selectLeaveTab(num: number) {
        this.leaveTabSelected = num;
    }

    public canAddLeave(): boolean {
        // HRM can add leave
        if (this.User.hasPermission("org.change_employee")) {
            return true;
        }

        // Check if the logged in user is a direct superior for the selected employee
        if (this.isDirectSubordinate) {
            return true;
        }

        // Default to no
        return false;
    }
}

angular.module('beneple.employees')
    .controller('EmployeeDetailController', EmployeeDetailController);



// WEBPACK FOOTER //
// ./frontend/scripts/employee/controllers/employee-detail.controller.ts